{
  "unsavedChanges": {
    "title": "Du har ændringer der ikke er gemt",
    "message": "Hvis du fortsætter, mister du de ændringer du har lavet. Er du sikker på, at du vil forlade siden?",
    "leave": "Forlad uden at gemme",
    "stay": "Bliv her"
  },
  "versionUpdate": {
    "message": "En ny version af EnergyConnect er tilgængelig. Opdater siden for at indlæse den seneste version.",
    "refresh": "Opdater siden"
  },
  "common": {
    "globalReaderMode": {
      "message": "EnergyConnect er midlertidigt skrivebeskyttet. Alle brugere har kun læseadgang."
    },
    "auth": {
      "login": "Log ind",
      "logout": "Log ud",
      "welcome": {
        "title": "Succesfuldt login",
        "description": "Du er nu logget ind og bliver automatisk dirigeret videre i løsningen"
      },
      "logoutscreen": {
        "title": "Log ud",
        "description": "Du bliver automatisk navigeret videre."
      }
    },
    "copytext": {
      "success": "Kopieret til udklipsholder",
      "error": "Kunne ikke kopiere til udklipsholder"
    },
    "graph": {
      "visualization": "Visning",
      "legend": "Vis labels",
      "details": "Vis detaljer",
      "dataSources": "Datakilder",
      "dateRange": "Datointerval",
      "consumption": "Forbrug (A+)",
      "production": "Produktion (A-)",
      "reactivepositive": "Reaktiv (R+)",
      "reactivenegative": "Reaktiv (R-)",
      "generated": "Genererede tidsserier",
      "missing": "Manglende tidsserier",
      "line": "Linjediagram",
      "bar": "Søjlediagram",
      "pie": "Cirkeldiagram",
      "doughnut": "Donutdiagram",
      "min": "Minimum",
      "max": "Maksimum",
      "average": "Gennemsnit",
      "median": "Median",
      "total": "Total",
      "readingvalue": "Aflæst"
    },
    "change": "Skift",
    "stop": "Stop",
    "energyConnect": "EnergyConnect",
    "dataHub": "DataHub",
    "advanced": "Avanceret",
    "searching": "Søgning",
    "attach": "Tilknyt",
    "add": "Tilføj",
    "shutdown": "Nedlæg",
    "copy": "Kopiér",
    "copy_to_clipboard": "Eksporter til udklipsholder",
    "copy_to_clipboard_success": "Eksporteret til udklipsholder",
    "export": "Eksporter",
    "sum": "Sum",
    "replace": "Udskift",
    "missingtranslation": "Mangler oversættelse af",
    "name": "Navn",
    "remove": "Fjern",
    "cancel": "Annullér",
    "yes": "Ja",
    "no": "Nej",
    "true": "Ja",
    "false": "Nej",
    "all": "Alle",
    "reset": "Nulstil",
    "resetall": "Nulstil alle",
    "connected": "Tilsluttet",
    "disconnected": "Afbrudt",
    "unknown": "Ukendt",
    "new": "Nyoprettet",
    "pending": "Afventende",
    "confirmed": "Opdateret",
    "rejected": "Afvist",
    "search": "Søg",
    "hour": "Time",
    "year": "År",
    "month": "Måned",
    "day": "Dag",
    "quarter": "Kvarter",
    "week": "Uge",
    "other": "Andet",
    "notspecified": "Ikke angivet",
    "loading": "Indlæser...",
    "select": "Vælg",
    "changedate": "Skæringsdato",
    "quadrant": "Kvadrant",
    "connect": "Tilslut",
    "disconnect": "Afbryd",
    "create": "Opret",
    "edit": "Redigér",
    "meter": "Måler",
    "show": "Vis",
    "complete": "Udfør",
    "define": "Angiv",
    "settings": "Indstillinger",
    "back": "Tilbage",
    "error": {
      "unknown": "Der er sket en ukendt fejl.",
      "notFound": "Den forespurgte ressource findes ikke.",
      "fetch": "Kunne ikke hentes"
    },
    "view": {
      "all": "Se alle"
    },
    "date": {
      "date": "Dato",
      "start": "Startdato",
      "end": "Slutdato",
      "validfrom": "Gyldig fra",
      "validto": "Gyldig til",
      "received": "Modtaget"
    },
    "table": {
      "index": "Indeks",
      "created": "Dato"
    },
    "user": {
      "createdby": "Oprettet af",
      "modifiedby": "Ændret af"
    },
    "version": {
      "title": "Version"
    },
    "close": "Luk",
    "next": "Næste",
    "previous": "Forrige"
  },
  "category": {
    "meteringpoint": "Målepunkt",
    "connectionpoint": "Tilslutningspunkt"
  },
  "error": {
    "email": "Angiv en korrekt e-mail",
    "pattern": "Skal være i godkendt format",
    "required": "Feltet er påkrævet",
    "datenotgreaterorequal": "Dato skal være {{ date }} eller senere",
    "datenotlessorequal": "Dato må ikke være senere end {{ date }}",
    "api": "Der skete en fejl",
    "min": "Værdien skal være over {{ min }}",
    "max": "Værdien må ikke overstige {{ max }}",
    "minlength": "Værdien skal være mindst {{ minlength }} tegn",
    "maxlength": "Værdien må ikke overstige {{ maxlength }} tegn",
    "lengthEqualTo": "Feltet matcher ikke den påkrævede længde.",
    "dateRangeExceeded": "Datointervallet må ikke overstige {{ maxDays }} dage",
    "dateRangeTooShort": "Datointervallet skal være mindst {{ minDays }} dage",
    "dateRangeMonthsExceeded": "Datointervallet må ikke overstige {{ maxMonths }} måneder",
    "server": {
      "internal": "Der skete en uventet fejl"
    },
    "authentication": {
      "denied": "Din adgang er fejlet. Du vil nu blive logget ud og ført til loginskærmen.",
      "forbidden": "Du har ikke rettigheder til at udføre den ønskede handling."
    },
    "generic": {
      "meteringPointReconnectNotDisconnected": "Målepunktet kunne ikke genoprettes, da det ikke er afbrudt.",
      "meteringPointConnectMeterNotValid": "Måleren er ikke gyldig."
    },
    "timeseries": {
      "daycount": "Antallet af dage er ikke tilstrækkeligt",
      "estimationfailed": "Estimering mislykkedes",
      "queryothermetereddatafailed": "Der kunne ikke hentes tidsserier fra det angivne målepunkt.",
      "invalidresolution": "Den valgte tidsopløsning er ikke gyldig"
    },
    "401": {
      "title": "Manglende adgang",
      "description": "Du har ikke adgang til den forespurgte side eller funktion. Hvis du har brug for adgang, bedes du kontakte din administrator eller leder."
    },
    "404": {
      "title": "Siden du søgte findes ikke",
      "description": "Af ukendte årsager kunne siden du søgte ikke findes. Du kan gå tilbage til forsiden af løsningen ved at klikke på knappen herunder."
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "connectionright": {
      "expiring": {
        "title": "Udløbende tilslutningsrettigheder",
        "date": "Udløbsdato"
      }
    },
    "datahub": {
      "communication": {
        "title": "DataHub",
        "v3": "DataHub",
        "fetchV3": "Modtag",
        "sendV3": "Send",
        "receive": "Modtag",
        "send": "Send",
        "success": "Succes",
        "lastSeen": "Senest opdateret",
        "total": "Total",
        "failures": "Fejl",
        "errorRate": "Fejlrate",
        "loadError": "Kunne ikke indlæse data"
      }
    },
    "system": {
      "title": "System"
    },
    "graph": {
      "missing": {
        "title": "Manglende tidsserier"
      },
      "generated": {
        "title": "Genererede tidsserier",
        "yAxis": "Antal"
      },
      "timeseries": {
        "title": "Tidsserier",
        "chartTitle": "Afvigelse for tidsserier"
      },
      "estimated": {
        "title": "Estimerede tidsserier",
        "chartTitle": "Afvigelse for estimerede tidsserier",
        "count": "Antal",
        "total": "I alt"
      },
      "noData": "Ingen data tilgængelig"
    },
    "deviation": {
      "title": "Genererede tidsserier",
      "subtitle": "Gennemsnit",
      "tooltip": {
        "value": "Værdi",
        "deviation": "Afvigelse"
      }
    },
    "oData": {
      "meteredDataNotCreated": {
        "title": "Forhindrede tidsserier"
      }
    },
    "overview": {
      "graphs": {
        "generatedtimeseries": "Tidsserier",
        "estimatedtimeseries": "Estimerede tidsserier"
      },
      "title": "Overblik",
      "timeseries": {
        "title": "Tidsserier"
      },
      "services": {
        "title": "Serviceydelser"
      },
      "meteringpoints": {
        "title": "Målepunkter"
      },
      "priceelements": {
        "title": "Priselementer"
      },
      "electricalheating": {
        "title": "Elvarme"
      },
      "dataconsistency": {
        "title": "Datakonsistens"
      },
      "pricestatus": {
        "title": "Status",
        "description": "Status for indsendelse af priser for timeopløste tariffer"
      },
      "systemstatus": {
        "title": "Systemstatus",
        "datahubinboxjob": "DataHub behandler beskeder",
        "datahubfetchjob": "DataHub modtager beskeder",
        "datahuboutboxjob": "DataHub sender beskeder",
        "followuponmissingmetereddatajob": "Behandling af opfølgning på manglende målerdata",
        "sendphysicalmetereddatajob": "Behandling af måledata fra fysiske målere",
        "sendvirtualmetereddatajob": "Behandling af måledata fra virtuelle målere",
        "sendmeterchangemetereddatajob": "Behandling af måledata fra Målerændringer",
        "structureddataeventconsumed": "Modtagelse målere fra MDM",
        "structureddataeventcreated": "Modtagelse af målere fra MDM",
        "conventionaldataeventconsumed": "Modtagelse af måledata fra MDM",
        "conventionaldataeventcreated": "Modtagelse af måledata fra MDM"
      }
    },
    "table": {
      "meteringpointid": "Målepunkt-ID",
      "partyname": "Elleverandør",
      "created": "Oprettelsesdato",
      "completion": "Udførelsesdato",
      "userresponse": "Besvar",
      "actionresponse": "Udfør",
      "serviceRequestCode": "Årsag",
      "status": "Status",
      "reason": "Bemærkning",
      "createdby": "Oprettet af",
      "pipelinetype": "Transaktionstype",
      "servicetype": "Serviceydelse",
      "meternumber": "Målernummer",
      "mainmeternumber": "Hovedmålernummer",
      "verificationmeternumber": "Kontrolmålernummer",
      "mappedquadrant": "Knyttet via kvadrant",
      "nonmappedquadrant": "Ikke koblet kvadrant",
      "expectedquadrant": "Forventet kvadrant",
      "consumptionnonmappedquadrant": "Dagsværdi",
      "productionobligation": "Aftagepligt",
      "chargeinformationidentification": "Priselement-ID",
      "chargetype": "Priselementstype",
      "chargeoccurrences": "Mængde",
      "statusreasoncode": "Årsagskode",
      "quadrant": "Kvadrant",
      "messagescount": "Antal modtagne beskeder",
      "oldestdayofwork": "Ældste driftsdøgn",
      "serialnumber": "Serienummer",
      "metertype": "Målertype",
      "occurrence": "Hændelsesdato",
      "balancesupplierdate": "Elleverandør valgt fra dato",
      "alternatemeternumber": "Alternativt målernummer",
      "description": "Navn",
      "longdescription": "Beskrivelse",
      "meterreadingoccurrence": "Tidsopløsning",
      "ownerenergyparty": "Ejer",
      "modifiedby": "Ændret af",
      "existsindatahub": "DataHub",
      "automationstarted": "Automatisering startet",
      "chargeinformation": "Priselement",
      "meterreadingts": "Seneste aflæsning",
      "meterreadingvalue": "Hovedmåler aflæsning",
      "verificationmeterreadingvalue": "Kontrolmåler aflæsning",
      "meterframeid": "Målerrammenavn",
      "meterframemaxcurrent": "Målerrammens tilslutningsrettighed (A)",
      "meterframemaxpower": "Målerrammens tilslutningsrettighed (kW)",
      "connectionpointmaxcurrent": "Tilslutningspunktets tilslutningsrettighed (A)",
      "connectionpointmaxpower": "Tilslutningspunktets tilslutningsrettighed (kW)",
      "peakconvertedquantity": "Spidsbelastning (kWh)",
      "totalpeakconvertedquantity": "Totale spidsbelastning (kWh)",
      "receivingtime": "Modtagelsestidspunkt",
      "ischild": "Child",
      "hasbalancesupplier": "Aktiv Elleverandør"
    },
    "remove": {
      "info": "Hvis du fortsætter, så tilkendegiver du at den markerede række er manuelt håndteret og ikke længere vises i oprulningen.",
      "label": "Ønsker du at fortsætte?",
      "approve": "Ja, fjern elementet",
      "deny": "Nej",
      "success": "Elementet er fjernet fra oprulningen.",
      "title": "Fjern",
      "failedautomation": {
        "info": "Hvis du fortsætter så tilkendegiver du at de {{ count }} fejlede automatiske pristilknytninger er manuelt håndteret og ikke længere skal vises i oprulningen.",
        "label": "Ønsker du at fortsætte?",
        "approve": "Ja, fjern elementerne fra oprulningen",
        "deny": "Nej, lad mig lige være helt sikker",
        "success": "Elementerne er fjernet fra oprulningen."
      }
    },
    "pricestatus": {
      "title": "Status for indsendelse af priser for timeopløste tariffer",
      "name": "Navn",
      "status": "Status",
      "chargeTypeId": "Priselement-ID",
      "nextGap": "Pris frem til nærmeste hul eller seneste dato",
      "priceslater": "Priser efter denne dato?"
    },
    "lockedtimeseries": {
      "title": "Målere med låste tidsserier",
      "removelock": {
        "title": "Fjern lås",
        "action": "Fjern lås",
        "description": "Fjern lås fra de valgte målepunkter?",
        "success": "Målepunkter oplåst"
      }
    },
    "electricalheating": {
      "create": {
        "title": "Afventer oprettelse af elvarme",
        "create": "Opret"
      },
      "remove": {
        "title": "Afventer nedlæggelse af elvarme",
        "action": "Nedlæg"
      },
      "date": "Dato",
      "e17identification": "Parent ID",
      "status": "Status",
      "e17datahubstatus": "Parent DataHub-status",
      "d14identification": "Child ID",
      "d14datahubstatus": "Child DataHub-status"
    },
    "timeseries": {
      "missing": {
        "title": "Manglende tidsserier",
        "dateofwork": "Driftsdøgn",
        "edit": "Redigér",
        "missingdatastatus": "Status",
        "errormessage": "Fejlbesked",
        "streetname": "Vejnavn",
        "housenumber": "Husnummer",
        "postalcode": "Postnummer",
        "meteringpointid": "Målepunkts-ID",
        "meteringpointtype": "Målepunktstype",
        "estimationgroup": "Estimeringsgruppe",
        "meteringpointsubtype": "Målepunktsart",
        "settlementmethod": "Afregningsform",
        "meterreadingoccurrence": "Tidsopløsning",
        "showHandled": "Vis behandlede",
        "markHandled": "Markér behandlet",
        "unmarkHandled": "Fjern markering",
        "comment": "Kommentar",
        "commentTitle": "Tilføj kommentar",
        "commentSuccess": "Kommentaren er gemt",
        "markHandledSuccess": "Markeret som behandlet",
        "commentMultiple": "Kommentaren skrives til alle {{count}} valgte rækker."
      },
      "meterreadingts": "Aflæsningstidspunkt",
      "meterreadingvalue": "Aflæsningsværdi"
    },
    "actionresponse": {
      "approved": "Godkendt",
      "manuallyhandled": "Manuelt håndteret",
      "rejected": "Afvist",
      "required": "Påkrævet",
      "notrequired": "Ikke påkrævet"
    },
    "userresponse": {
      "required": "Påkrævet",
      "approved": "Godkendt",
      "rejected": "Afvist",
      "notrequired": "Ikke påkrævet"
    },
    "reply": {
      "title": "Besvar"
    },
    "complete": {
      "title": "Udfør"
    },
    "list": {
      "title": "Køreliste"
    },
    "query": {
      "queryconnect": "Genåbning af målepunkt",
      "querydisconnect": "Ordinær afbrydelse af målepunkt",
      "querydisconnectduetoendofsupply": "Afbrydelse pga. leveranceophør",
      "queryclosedown": "Nedlæggelse af målepunkt",
      "querychangestoproductionobligation": "Ændring i aftagepligt",
      "querynewmeteringpointwithsupplier": "Nyoprettede målepunkter, hvor der er valgt elleverandør",
      "querymeteringpointchargeinformationrejected": "Afviste relationer mellem priselement og målepunkt",
      "queryghostmeters": "Målere kun kendt af EnergyConnect",
      "querymeteringpointchargeinformationpending": "Afventende relationer mellem priselement og målepunkt",
      "querymetersnotindhm": "Målepunkter der modtages beskeder på, men mangler i EnergyConnect",
      "querymissingelectricalheating": "Afventer oprettelse af elvarme",
      "queryremovalofelectricalheating": "Afventer fjernelse af elvarme",
      "querymetersnotconnected": "Aktive målere uden målerramme",
      "querychargeinformationrejectedbydatahub": "Priselementer afvist af DataHub",
      "querychargeinformationoverduepending": "Priselementer afventer med udløbet tidsfrist",
      "querymeteringpointsoverduepending": "Målepunkter afventer med udløbet tidsfrist",
      "list": {
        "downloadinfo": "Download af kørelisten starter automatisk."
      },
      "querydeviatingmeters": "Afvigelser mellem kontrolmåler og hovedmåler",
      "deviatingmeters": {
        "title": "Afvigelser mellem kontrolmåler og hovedmåler"
      },
      "queryusedverificationmeterreadings": "Brugte kontrolmålinger de seneste 14 dage",
      "usedverificationmeterreadings": {
        "title": "Alle brugte kontrolmålinger"
      },
      "querymeteringpointquadrantmismatch": "Målepunkter med forkert kvadrant",
      "exceedingpowerlimits": {
        "title": "Overskridelser af tilslutningsrettigheden",
        "slow-warning": "Denne forespørgsel kan tage lang tid at indlæse"
      },
      "metereddatanotcreated": {
        "title": "Forhindrede tidsserier"
      },
      "rejectedchargeinformation": {
        "title": "Afviste priselementer"
      },
      "failedautomations": {
        "title": "Opfølgning på automatiserede pristilknytninger"
      },
      "missingelectricalheating": {
        "title": "Afventer oprettelse af elvarme"
      },
      "removalelectricalheating": {
        "title": "Afventer nedlæggelse af elvarme"
      },
      "changestoproductionobligation": {
        "title": "Ændringer i aftagepligt"
      },
      "connect": {
        "title": "Genåbning af målepunkt"
      },
      "meterControl": {
        "title": "Målerundersøgelse"
      },
      "withoutrelations": {
        "title": "Målepunkter uden tidsseriekilde"
      },
      "metersnotconnected": {
        "title": "Aktive målere uden målerramme"
      },
      "notindhm": {
        "title": "Målepunkter der modtages beskeder på, men mangler i EnergyConnect",
        "request": "Anmod om stamdata"
      },
      "newmeteringpointwithsupplier": {
        "title": "Nyoprettede målepunkter, hvor der er valgt elleverandør",
        "search": {
          "datahubStatus": "DataHub Status",
          "address": "Adresse"
        }
      },
      "meteringpointchargeinformationpending": {
        "title": "Afventende relationer mellem priselement og målepunkt"
      },
      "overduechargeinformation": {
        "title": "Afventende priselementer",
        "requestprice": "Anmod om priselement",
        "chargetypeid": "Priselement-ID",
        "chargetype": "Priselementstype",
        "owner": "Aktør",
        "start": "Startdato",
        "end": "Slutdato"
      },
      "ghostmeters": {
        "title": "Målere kun kendt af EnergyConnect"
      },
      "meteringpointchargeinformationrejected": {
        "title": "Afviste relationer mellem priselement og målepunkt",
        "manuallyhandled": "Håndteret manuelt",
        "info": "Ved at gennemføre denne handling markeres sagen som løst manuelt og fjernes fra oversigten. Er du sikker?",
        "success": "Sagen er sat til manuelt håndteret og fjernet fra oversigten.",
        "error": "Kunne ikke ændre status og fjerne sagen fra oversigten."
      },
      "unbalancedquantity": {
        "title": "Målere med ubalanceret energi",
        "info": "Data opdateres hver morgen.",
        "dismiss": "Fjern",
        "remove": {
          "title": "Fjern målepunkter",
          "info": "Du er ved at fjerne {{ count }} målepunkt(er) fra oprulningen. Den underliggende data slettes ikke.",
          "label": "Ønsker du at fjerne de {{ count }} valgte målepunkter?",
          "approve": "Ja, fjern elementerne",
          "deny": "Nej",
          "success": "Målepunkterne er fjernet fra oprulningen."
        }
      },
      "disconnect": {
        "title": "Ordinær afbrydelse af målepunkt"
      },
      "deliverydisconnect": {
        "title": "Afbrydelse pga. leveranceophør"
      },
      "reopen": {
        "title": "Anmodning om genåbning af målepunkt"
      },
      "closedown": {
        "title": "Anmodning om nedlæggelse af målepunkt"
      },
      "rejectedmeteringpoints": {
        "title": "Målepunkter afvist af DataHub"
      },
      "meteringpointsoverduepending": {
        "title": "Målepunkter afventer med udløbet tidsfrist"
      }
    },
    "service": {
      "reading": {
        "title": "Anmodning om aflæsning"
      },
      "metercheck": {
        "title": "Anmodning om målerundersøgelse"
      }
    },
    "servicerequest": {
      "title": "Serviceydelser",
      "pipelinetype": "Transaktionstype",
      "createdts": "Oprettet",
      "occurrence": "Udført",
      "createdby": "Oprettet af",
      "userresponse": "Besvar",
      "actionresponse": "Udfør",
      "status": {
        "title": "Status",
        "cancelledbysupplier": "Annulleret af elleverandør"
      },
      "remove": {
        "title": "Fjern",
        "info": "Elleverandøren har annulleret serviceydelsen, så eventuelle planlagte aktiviteter skal ikke udføres alligevel. Tryk på OK for at fjerne serviceydelsen fra oprulningen. Der sendes ingen information til DataHub vedr. dette.",
        "confirm": "Du er ved at fjerne serviceydelsen vedrørende målepunktet fra oprulningen. Er du sikker?",
        "success": "Serviceydelsen er fjernet fra oprulningen."
      },
      "comment": "Bemærkning",
      "metercheck": "Anmodning om målerundersøgelse",
      "metercontrol": {
        "title": "Anmodning om målerundersøgelse"
      },
      "readingrequest": "Anmodning om aflæsning",
      "reply": {
        "date": "Skæringsdato",
        "comment": "Bemærkning",
        "answer": "Svar",
        "approve": "Ja, godkend",
        "deny": "Nej, afvis",
        "meteringpoint": "Målepunkt-ID",
        "title": "Besvar",
        "success": "Serviceydelsen er indsendt."
      },
      "complete": {
        "title": "Udfør",
        "meteringpoint": "Målepunkt-ID",
        "date": "Skæringsdato",
        "reply": "Svar",
        "approve": "Godkend",
        "deny": "Afvis",
        "info": "Vær opmærksom på, at afbrydelsen først må sendes til DataHub, efter en fysisk afbrydelse er gennemført.",
        "reasontext": "Beskrivelse",
        "reasontype": "Årsagstype",
        "reject": "Bemærk at denne handling, ikke sender en besked til DataHub.",
        "displayprocessed": "Vis behandlede serviceydelser",
        "dateHelpText": "Datoen skal være i dag eller seneste hverdag."
      },
      "disconnect": {
        "reply": "Ved godkendelse bekræftes det, at man vil forsøge at afbryde målepunktet på skæringsdatoen.",
        "completeapprove": "Du afbryder nu målepunktet på nedenstående skæringsdato.",
        "completeinfo": "Vær opmærksom på, at målepunktet afbrydes, når der trykkes 'Indsend'."
      },
      "disconnectDueToEndOfSupply": {
        "reply": "Ved godkendelse bekræftes det, at man vil forsøge at afbryde målepunktet på skæringsdatoen.",
        "completeinfo": "Vær opmærksom på, at målepunktet afbrydes, når der trykkes 'Indsend'.",
        "completeapprove": "Pga. leveranceophør afbryder du nu målepunktet på nedenstående skæringsdato.",
        "completereject": "Ved afvisning sendes der en besked til DataHub, men målepunktet afbrydes ikke."
      },
      "reconnect": {
        "reply": "Ved godkendelse bekræftes det, at man vil forsøge at genåbne målepunktet på skæringsdatoen.",
        "completeinfo": "Vær opmærksom på, at genåbningen først må sendes til DataHub, efter en fysisk genåbning er gennemført.",
        "completeapprove": "Du genåbner nu målepunktet på nedenstående skæringsdato.",
        "forcereconnect": "Gennemtving genåbning"
      },
      "closeDown": {
        "reply": "Ved godkendelse bekræftes det, at man vil forsøge at nedlægge målepunktet på skæringsdatoen.",
        "completeinfo": "Vær opmærksom på, at målepunktet nedlægges, når der trykkes 'Indsend'.",
        "completeapprove": "Du nedlægger nu målepunktet på nedenstående skæringsdato."
      },
      "cancelledbysupplierwarning": "Elleverandøren har annulleret serviceydelsen, så eventuelle planlagte aktiviteter skal ikke udføres alligevel."
    }
  },
  "settlement": {
    "title": "Afstemning",
    "notspecified": "Ikke angivet",
    "flexsettled": "Flexafregnet",
    "profiled": "Timeafregnet",
    "nonprofiled": "Andet",
    "search": {
      "startdate": "Startdato",
      "enddate": "Slutdato",
      "meteringpointtype": "Målepunktstype",
      "settlementmethod": "Afregningsform",
      "businessreasoncode": "Forretningsproces",
      "processvariant": "Procesvariant",
      "datahubstatus": "DataHub-status"
    },
    "actions": {
      "view": "Vis",
      "request": "Anmod",
      "export": "Eksportér",
      "exportReport": "Eksporter Engrosafregning"
    },
    "view": {
      "details": "Detaljer",
      "data": "Data",
      "request": "Anmodning",
      "answer": "Svar"
    },
    "table": {
      "receiveddate": "Modtagelsesdato",
      "startdate": "Startdato",
      "enddate": "Slutdato",
      "businessreasoncode": "Forretningsproces",
      "processvariant": "Procesvariant",
      "resolutionduration": "Opløsning",
      "productidentification": "Produkt",
      "unittype": "Enhed",
      "typeofmeteringpoint": "Målepunktstype",
      "settlementmethod": "Afregningsform",
      "version": "Version"
    },
    "profile": {
      "title": "Andelstal"
    },
    "metered": {
      "title": "Energitidsserier",
      "request": {
        "title": "Anmod",
        "businessreasoncode": "Forretningsproces",
        "gridarea": "Netområde",
        "meteringpointtype": "Målepunktstype",
        "settlementmethod": "Afregningsform",
        "product": "Produkt",
        "startdate": "Startdato",
        "enddate": "Slutdato",
        "success": "Anmodning afsendt"
      },
      "view": {
        "title": "Vis detaljer",
        "quantity": "Kvantum",
        "day": "Driftsdøgn",
        "quantityquality": "Kvantumstatus"
      }
    },
    "wholesale": {
      "title": "Engrosydelser",
      "settlementmethod": "Afregningsform",
      "businessreasoncode": "Forretningsproces",
      "processvariant": "Procesvariant",
      "balancesupplieridentification": "Elleverandør",
      "meteringpointtype": "Målepunktstype",
      "chargetype": "Priselementstype",
      "chargetypeid": "Priselement-ID",
      "chargeowner": "Priselement-ejer",
      "datahubstatus": "DataHub Status",
      "gridarea": "Netområde",
      "balancesupplier": "Elleverandør",
      "request": {
        "title": "Anmod"
      },
      "view": {
        "title": "Vis detaljer",
        "energyprice": "Energipris",
        "energysum": "Energisum"
      },
      "exportReport": {
        "title": "Eksporter Engrosafregning",
        "export": "Eksportér",
        "selectTypes": "Medtag korrektioner",
        "error": "Fejl ved eksport af afregningsrapport. Prøv igen."
      }
    },
    "billing": {
      "title": "Afregningsgrundlag"
    }
  },
  "frame": {
    "information": "Information",
    "masterdata": "Stamdata",
    "product": "Produkt"
  },
  "menu": {
    "actors": "Aktørregister",
    "connectionpoint": "Tilslutningspunkt",
    "dashboard": "Dashboard",
    "market": "Marked",
    "measurementpoint": "Målepunkt",
    "model": "Model",
    "overview": "Overblik",
    "pricing": "Priselementer",
    "search": "Søg",
    "settlement": "Afstemning",
    "vee": "VEE",
    "developer": "Udvikler",
    "hangfire": "Baggrundsjobs"
  },
  "meter": {
    "address": "Adresse",
    "billingtype": "Afregning",
    "child": "Child",
    "meterId": "Måler-ID",
    "currentMeter": "Nuværende måler",
    "newMeter": "Valgt måler",
    "connectivitystatus": "Tilslutningsstatus",
    "coredata": "Anmod om stamdata",
    "create": "Opret",
    "searchForMeter": "Søg efter måler",
    "information": "Information",
    "product": "Produkt",
    "quadrant": "Kvadrant-mapping",
    "conversionFactors": {
      "A14": "A14",
      "A23": "A23",
      "R12": "R12",
      "R34": "R34"
    },
    "replaceAttach": {
      "info": "Fremsøg og vælg måler",
      "noMeterFrame": "Der blev ikke fundet en matchende målerramme. Luk vinduet og forsøg igen.",
      "attach": {
        "title": "Tilknyt måler",
        "success": "Måleren blev tilknyttet"
      },
      "replace": {
        "title": "Skift måler",
        "success": "Målerudskift registreret"
      }
    },
    "quadrantTypes": {
      "NotSpecified": "[NotSpecified]",
      "Consumption": "Forbrug (A+)",
      "Production": "Produktion (A-)",
      "ReactivePositive": "Reaktiv (R+)",
      "ReactiveNegative": "Reaktiv (R-)"
    },
    "remove": {
      "title": "Fjern måler"
    },
    "calculation": "Omregningsfaktorer",
    "htx": {
      "notspecified": "Ikke angivet",
      "primary": "Primær",
      "secondary": "Sekundær"
    },
    "createform": {
      "create": "Opret måler",
      "activefrom": "Gyldig fra",
      "amplimit": "Effektgrænse",
      "assettype": "Anlægsteknologi",
      "capacity": "Anlægskapacitet",
      "city": "By",
      "comments": "Målepunktskommentar",
      "connectionpointaddress": "Tilslutningspunktadresse",
      "connectionpointidentification": "Tilslutningspunktnummer",
      "connectiontype": "Tilslutningstype",
      "countrycode": "Landekode",
      "daraddress": "Adresseopslag (DAR)",
      "deliveryarea": "Netområde",
      "disconnectiontype": "Afbrydelsesart",
      "door": "Dør",
      "findconnectionpoint": "Fremsøg tilslutningspunkt",
      "fromgrid": "Fra netområde",
      "gsrn": "Værks-GSRN",
      "hour": "Time",
      "id": "Målepunkt-ID",
      "kwlimit": "Effektgrænse",
      "measurementcompleted": "Aflæsning foretaget",
      "meterId": "Målernummer",
      "meterType": "Målertype",
      "meterdigits": "Målercifre",
      "meterreadingoccurrence": "Aflæsning foretaget",
      "meterunit": "Målerenhed",
      "month": "Måned",
      "mpformat": "Målepunktsart",
      "mptype": "Målepunktstype",
      "municipalcode": "Kommunekode",
      "netsettlementgroup": "Nettoafregningsgruppe",
      "number": "Husnummer",
      "other": "Andet",
      "parentid": "Parent målepunkt ID",
      "postaldistrict": "Postområde",
      "product": "Produkt",
      "quarter": "Kvarter",
      "roadcode": "Vejkode",
      "roadname": "Vejnavn",
      "settlementmethod": "Afregningsform",
      "story": "Etage",
      "title": "Måler",
      "togrid": "Til netområde",
      "unit": "Enhed",
      "zip": "Postnummer"
    },
    "datahub": "DataHub Status",
    "deliverycompany": "Aktiv elleverandør",
    "edit": "Redigér",
    "id": "Id",
    "location": "Lokationsdetaljer",
    "measurementdetails": "Måledetaljer",
    "meterdetails": "Målerdetaljer",
    "meterNumber": "Målernummer",
    "alternativeMeterNumber": "Alternativt målernummer",
    "serialNumber": "Serienummer",
    "commissioningDate": "Måler indsættelsesdato",
    "meterid": "Målernummer",
    "meteringtype": "Målepunktstype",
    "physical": "Fysiske detaljer",
    "relatedMeteringPoints": "Direkte relaterede målepunkter",
    "acquisitionDate": "Anskaffelsesdato",
    "accuracyClass": "Nøjagtighedsklasse",
    "comment": "Bemærkning",
    "measurementPrinciple": "Måleprincip",
    "ctTurnOverRatio": "Strømtransformer CT",
    "vtTurnOverRatio": "Spændingstransformer VT",
    "search": {
      "placeholder": "Søg i målepunkt..."
    },
    "show": "Vis",
    "shutdown": "Nedlæg",
    "title": "Måler",
    "readingType": "Type",
    "conversionFactor": "Omregningsfaktor",
    "readingTypes": {
      "title": "Målertype",
      "NotSpecified": "Ukendt",
      "Accumulated": "Akkumulerende",
      "Balanced": "Salderende",
      "None": "Ingen"
    },
    "meterCreated": "Måler oprettet",
    "meterUpdated": "Måler opdateret",
    "meterClosed": "Måler nedlagt",
    "accuracyClasses": {
      "notspecified": "[NotSpecified]",
      "a": "A",
      "b": "B",
      "c": "C",
      "zeropointtwos": "0,2S",
      "zeropointfive": "0,5"
    },
    "measurementPrinciples": {
      "summation": "Summation",
      "phase": "Fase"
    },
    "ctTurnOverRatios": {
      "ct505": "50/5",
      "ct755": "75/5",
      "ct1005": "100/5",
      "ct1505": "150/5",
      "ct2005": "200/5",
      "ct3005": "300/5",
      "ct4005": "400/5",
      "ct5005": "500/5",
      "ct6005": "600/5",
      "ct8005": "800/5",
      "ct10005": "1000/5",
      "ct12005": "1200/5",
      "ct12505": "1250/5",
      "ct15005": "1500/5",
      "ct16001": "1600/1",
      "ct16005": "1600/5",
      "ct17255": "1725/5",
      "ct20005": "2000/5",
      "ct25005": "2500/5",
      "ct30005": "3000/5"
    },
    "vtTurnOverRatios": {
      "vt10000100": "10000/100",
      "vt10000110": "10000/110",
      "vt11000110": "11000/110",
      "vt230400": "230/400",
      "vt60000100": "60000/100",
      "vt60000110": "60000/110",
      "vt690400": "690/400"
    }
  },
  "address": {
    "title": "Adresse",
    "chooseAddress": "Vælg Bopælsadresse",
    "chooseAccessAddress": "Vælg Adgangsadresse",
    "chooseAnyAddress": "Vælg Adresse",
    "streetPostalCode": "Vej og postnummer",
    "addressType": "Adressetype",
    "streetName": "Vejnavn",
    "streetNumber": "Husnummer",
    "houseNumber": "Husnummer",
    "washInstructions": "Vaskeanvisning",
    "floor": "Etage",
    "zipCode": "Postnummer",
    "city": "By",
    "daraddress": "Adresseopslag (DAR)",
    "roadcode": "Vejkode",
    "door": "Dør",
    "postaldistrict": "Postområde",
    "countrycode": "Landekode",
    "municipalcode": "Kommunekode",
    "cleanAddress": "Vask adresse",
    "addresssanitized": "Adresse vasket",
    "notunique": "Adressen er ikke unik",
    "notfound": "Adressen blev ikke fundet",
    "multiplematches": "Flere adresser matcher. Præcisér adressen, eller vælg den via søgning",
    "roomIdentification": "Dørbetegnelse",
    "streetCode": "Vejkode",
    "darReference": "DAR-ID"
  },
  "meteringpoint": {
    "root": {
      "title": "Anmod om stamdata"
    },
    "table": {
      "allowChanges": "Tillad ændringer",
      "address": "Adresse",
      "existsInDataHub": "Findes i DataHub",
      "created": "Oprettet",
      "id": "ID",
      "identification": "Identifikation",
      "isMeterActive": "Måler aktiv",
      "meterNumber": "Målernummer",
      "meterQuadrant": "Målerkvadrant",
      "meterReadingOccurrence": "Tidsopløsning",
      "meteringPointSubType": "Undertype",
      "netSettlementGroup": "Nettoafregningsgruppe",
      "ownership": "Ejer",
      "productCharacteristicIdentification": "Produkt",
      "productCharacteristicUnitType": "Produktenhed",
      "gridArea": "Netområde"
    },
    "pricing": {
      "chargetype": "Priselement",
      "chargetypeid": "Priselement-ID",
      "owner": "Ejer",
      "taxindicator": "Afgift",
      "transparentinvoicing": "Viderefakturering",
      "chargeoccurrence": "Mængde",
      "statusreasoncode": "Årsagskode",
      "unknownstatus": "Ukendt status",
      "requestMasterDataCharge": "Anmod om afregningsstamdata",
      "requestMasterDataChargeSuccesful": "Afregningsstamdata anmodet",
      "associateChargeInformation": "Opret binding mellem målepunkt og priselement",
      "updateAssociateChargeInformationSuccesful": "Binding mellem målepunkt og priselement opdateret",
      "disassociateChargeInformationSuccesful": "Binding mellem målepunkt og priselement stoppet"
    },
    "businesstransaction": {
      "answerrequest": "Besvar",
      "show": {
        "title": "Vis",
        "details": "Detaljer",
        "message": "Besked",
        "transactiontype": "Transaktionstype",
        "rsmname": "RSM-navn",
        "rsmnumber": "RSM-nummer",
        "brcreasoncode": "Årsagskode (BRC)",
        "service": "Serviceydelse",
        "reasoncode": "Årsagskode",
        "reason": "Årsag",
        "userresponse": "Kræver besvarelse",
        "respondedby": "Besvaret af",
        "respondeddate": "Besvarelsesdato",
        "actionresponse": "Kræver udførsel",
        "actionrespondedby": "Udført af",
        "actionrespondedts": "Udførelsesdato",
        "createdby": "Oprettet af",
        "createddate": "Oprettelsesdato"
      },
      "hidetidsserier": "Skjul tidsserier",
      "showtidsserier": "Vis tidsserier",
      "tidsserierhidden": "Tidsserier vises ikke i øjeblikket"
    },
    "create": {
      "installationlocation": "Installationsadresse",
      "physicaldetails": "Fysiske detaljer",
      "metercharacteristics": "Måler- og målepunktsdetaljer",
      "title": "Opret målepunkt",
      "template": "Anvend skabelon",
      "usetemplate": "Anvend skabelon til oprettelse",
      "summary": "Opsummering",
      "success": "Målepunktet er oprettet.",
      "meteringpointtype": "Målepunktstype"
    },
    "coredata": {
      "addresstype": "Adressetype",
      "addresstypes": {
        "judicialaddress": "Juridisk adresse",
        "technicaladdress": "Teknisk adresse"
      }
    },
    "calculation": {
      "algorithm": "Algoritme",
      "addmeteringpoint": "Tilføj målepunkt",
      "definemp": "Angiv målepunkts-ID",
      "descriptions": {
        "mp1": "Overfører en tidsserie fra et målepunkt til et andet. MP1 kan være time eller kvartersopløst.",
        "mp1minusmp2": "Formlen kan trække måledata for to målepunkter fra hinanden. De to værdier trækkes fra hinanden. Resultatet er i samme opløsning (time eller kvarter) som formlens målepunkt og benyttes som værdi i en ny tidsserie.",
        "posmp1mp2annual": "Formlen kan trække måledata for to målepunkter fra hinanden. Efter udregning opsummeres alle værdier og det tjekkes om summen er negativ. Er den negativ, sættes resultatet til 0. Er den positiv, sættes den til værdien af beregningen. Resultatet benyttes som værdi i en ny tidsserie.",
        "posmp1mp2": "Formlen kan trække måledata for to målepunkter fra hinanden. Efter subtrahering tjekkes det, om værdierne er negative. Er de negative, sættes resultatet til 0. Er de positive, sættes de til værdien af beregningen. Resultatet er i samme opløsning (time eller kvarter) som formlens målepunkt og benyttes som værdi i en ny tidsserie.",
        "mp1mp2mp3": "Formlen lægger måledata for to målepunkter sammen og trækker måledata for et tredje fra. Værdierne for MP1 og MP2 lægges sammen og fratrækkes MP3. Resultatet er i samme opløsning (time eller kvarter) som formlens målepunkt og benyttes som værdi i en ny tidsserie.",
        "posmp1mp2mp3": "Formlen lægger måledata for to målepunkter sammen og trækker måledata for et tredje fra. Værdierne for MP1 og MP2 lægges sammen og fratrækkes MP3. Er det samlede resultat negativ, bruges værdien 0 i stedet for den faktiske værdi. Resultatet er i samme opløsning (time eller kvarter) som formlens målepunkt og benyttes som værdi i en ny tidsserie.",
        "mp1plusmp2": "Formlen lægger måledata for to målepunkter sammen. Værdierne for MP1 og MP2 lægges sammen. Resultatet er i samme opløsning (time eller kvarter) som formlens målepunkt og benyttes som værdi i en ny tidsserie.",
        "annual": "Laver en lineær fordeling af forventet årsforbrug",
        "dynamic": "Formlen lægger måledata for x målepunkter sammen.",
        "forholdsfordelt": "Formlen fordeler måledata forholdsvist. MP1 er den samlede måling og MP2 er målepunktets egenmåling. De øvrige målepunkter (summåling) indgår som grundlag for den forholdsmæssige fordeling."
      },
      "summaling": "Summåling"
    },
    "template": {
      "templateconsumptionvirtualflex": "E17 - Virtuel Flexafregnet",
      "templateconsumptionvirtualhour": "E17 - Virtuel Timeafregnet",
      "templateproductionvirtualquarterly": "E18 - Virtuel Kvartersaflæst",
      "templatesupplytogridquarterly": "D06 - Fysisk Kvartersaflæst",
      "templateconsumptionfromgridquarterly": "D07 - Fysisk Kvartersaflæst"
    },
    "type": {
      "veproduction": "D01 - VE-produktion",
      "analysis": "D02 - Analysemålepunkt",
      "surplusproductiongroup": "D04 - Overskudsmålepunkt",
      "netproduction": "D05 - Nettoproduktion",
      "supplytogrid": "D06 - Leveret til net",
      "consumptionfromgrid": "D07 - Forbrugt fra net",
      "wholesaleservices": "D08 - Afregningsgrundlag / information",
      "ownproduction": "D09 - Egenproduktion",
      "netfromgrid": "D10 - Netto fra net",
      "nettogrid": "D11 - Netto til net",
      "totalconsumption": "D12 - Bruttoforbrug",
      "gridlosscorrection": "D13 - Nettabskorrektion",
      "electricalheating": "D14 - Elvarme",
      "nettoconsumption": "D15 - Nettoforbrug",
      "internaluse": "D99 - Intern brug",
      "consumption": "E17 - Forbrugsmålepunkt",
      "production": "E18 - Produktionsmålepunkt",
      "exchange": "E20 - Udvekslingsmålepunkt",
      "otherconsumption": "D17 - Øvrigt forbrug",
      "otherproduction": "D18 - Øvrig produktion",
      "effectpayment": "D19 - Effektbetaling",
      "exchangereactiveenergy": "D20 - Udveksling - reaktiv energi",
      "collectivenetproduction": "D21 - Kollektiv nettoproduktion",
      "collectivenetconsumption": "D22 - Kollektivt nettoforbrug"
    },
    "title": "Målepunkt",
    "identification": "Målepunkts-ID",
    "search": {
      "placeholder": "Søg i målepunkt..."
    },
    "unittype": "Målerenhed",
    "serialnumber": "Serienummer",
    "meternumber": "Målernummer",
    "controlmeter": "Kontrolmåler",
    "comments": "Kommentar",
    "location": {
      "title": "Lokationsdetaljer",
      "washInstructions": {
        "notspecified": "Ikke angivet",
        "washable": "Vaskbar",
        "notwashable": "Ikke vaskbar"
      }
    },
    "timeseries": {
      "estimated": "Estimeret",
      "asread": "Målt",
      "request": {
        "title": "Anmod om tidsserier",
        "businesscode": "Forretningsproces",
        "success": "Anmodning gemt"
      },
      "submit": {
        "title": "Indsend manuel tidsserie",
        "periodusage": "Periodeforbrug",
        "estimationmethod": "Fordeling",
        "quantityquality": "Kvantumstatus",
        "unittype": "Måleenhed",
        "resolution": "Tidsopløsning",
        "clearintervals": "Ryd intervaller",
        "invaliddaterange": "Startdato og slutdato må ikke være den samme – vælg et interval på mindst én dag.",
        "wantslocked": "Lås tidsserierne",
        "confirm": "Du er ved at oprette en manuel tidsserie på {{ days }} dage, hvilket kan bevirke at løsningen føles langsom imens. Vil du fortsætte?"
      },
      "advancedsubmit": {
        "title": "Indsend Machine Learning tidsserier"
      },
      "graph": {
        "show": "Vis graf",
        "hide": "Skjul graf"
      },
      "manualsubmit": {
        "success": "Tidsserier indsendt",
        "title": "Indsend manuel tidsserie"
      },
      "locktimeseries": {
        "title": "Lås tidsserier",
        "lock": {
          "title": "Lås",
          "action": "Lås",
          "description": "Ønsker du at låse de valgte tidsserier?",
          "success": "Tidsserier låst"
        }
      }
    },
    "disconnect": {
      "disconnectInfo": "Vær opmærksom på, at afbrydelsen først må sendes til DataHub, efter en fysisk afbrydelse er gennemført.",
      "disconnectSuccess": "Afbrydelse gemt"
    },
    "reconnect": {
      "action": "Genåbn",
      "title": "Genåbn",
      "reconnectInfo": "Vær opmærksom på, at genåbningen først må sendes til DataHub, efter en fysisk genåbning er gennemført."
    },
    "contact": {
      "title": "Kontaktinformation"
    },
    "customer": {
      "title": "Kundeinformation"
    },
    "masterdata": {
      "from": "Fra"
    },
    "source": {
      "title": "Tidsseriekilde",
      "source": "Kilde",
      "parameters": "Formelparametre",
      "addmeter": {
        "title": "Tilknyt måler",
        "success": "Måler tilknyttet"
      },
      "addcalculation": {
        "title": "Tilknyt formel",
        "success": "Formel tilknyttet"
      },
      "addcontrolmeter": {
        "title": "Tilknyt kontrolmåler"
      },
      "stopcontrolmeter": {
        "title": "Stop kontrolmålerrelation"
      },
      "remove": {
        "title": "Fjern relation",
        "action": "Fjern",
        "success": "Relationer fjernet",
        "description": "Følgende relationer fjernes. Den forudgående relation forlænges, så den dækker den fjernede periode, og der dannes nye tidsserier for den berørte periode. Handlingen kan ikke fortrydes."
      }
    },
    "meter": {
      "title": "Målerdetaljer",
      "selectmeter": "Vælg måler",
      "selectquadrant": "Vælg kvadrant",
      "option": {
        "serialnumber": "Serienummer: {{ value }}",
        "location": "Placering: {{ value }}",
        "meternumber": "Målernummer: {{ value }}",
        "nometernumber": "Ingen målernummer"
      },
      "meternumber": "Målernummer",
      "serialnumber": "Serienummer",
      "controlmeter": "Kontrolmåler",
      "comments": "Bemærkninger",
      "sendTimeSeries": "Send tidsserier for perioden",
      "create": {
        "title": "Opret måler"
      },
      "stop": {
        "title": "Nedtag måler",
        "action": "Nedtag",
        "success": "Nedtagning af måler registreret"
      },
      "change": {
        "title": "Skift måler",
        "meternumber": "Målernummer",
        "serialnumber": "Serienummer",
        "unittype": "Målerenhed",
        "meterreadingtype": "Målertype",
        "subtype": "Målepunktsundertype",
        "selectsubtype": "Vælg målepunktsundertype"
      },
      "htx": {
        "title": "Lav HTX",
        "success": "HTX gemt"
      },
      "createcontrolmeter": {
        "title": "Opret kontrolmåler",
        "success": "Kontrolmåler oprettet",
        "relativedeviation": "Relativ afvigelse (%)",
        "absolutedeviation": "Absolut afvigelse (kWh)"
      },
      "removecontrolmeter": {
        "title": "Nedtag kontrolmåler",
        "success": "Kontrolmåler nedtaget"
      }
    },
    "meterdetails": {
      "title": "Måledetaljer",
      "gridAreaIdentification": "Netområde",
      "estimatedAnnualVolume": "Forventet årsforbrug",
      "meterReadingDate01": "Planlagt måleraflæsning 01",
      "meterReadingDate02": "Planlagt måleraflæsning 02",
      "meterReadingDate03": "Planlagt måleraflæsning 03",
      "meterReadingDate04": "Planlagt måleraflæsning 04",
      "meterReadingDate05": "Planlagt måleraflæsning 05",
      "meterReadingDate06": "Planlagt måleraflæsning 06",
      "meterReadingDate07": "Planlagt måleraflæsning 07",
      "meterReadingDate08": "Planlagt måleraflæsning 08",
      "meterReadingDate09": "Planlagt måleraflæsning 09",
      "meterReadingDate10": "Planlagt måleraflæsning 10",
      "meterReadingDate11": "Planlagt måleraflæsning 11",
      "meterReadingDate12": "Planlagt måleraflæsning 12",
      "hourlyTimeSeries": "Timedata",
      "meterreadingoccurrence": {
        "year": "Årligt",
        "month": "Månedligt",
        "day": "Dagligt",
        "hour": "Hver time",
        "quarter": "Hvert kvarter",
        "other": "Andet"
      }
    },
    "physical": {
      "title": "Fysiske detaljer"
    },
    "children": {
      "title": "Child målepunkter",
      "identification": "Målepunkts-ID"
    },
    "history": "Historik",
    "csvupload": {
      "title": "Upload manuelle tidsserier via CSV",
      "dropzone": {
        "label": "Træk og slip en CSV-fil her, eller klik for at vælge",
        "sublabel": "Kun .csv-filer er understøttet",
        "invalidType": "Kun .csv-filer er understøttet"
      },
      "formInvalid": "Formularen er ikke udfyldt korrekt",
      "filename": "Filnavn",
      "upload": "Upload",
      "uploading": "Uploader fil...",
      "sizelimit": "Filstørrelse begrænset til 10 MB",
      "uploadsuccess": "CSV-upload af manuelle tidsserier gennemført",
      "uploadfailed": "CSV-upload af manuelle tidsserier mislykket. Tjek formatet.",
      "help": "Upload CSV-fil med manuelle tidsserier. Filen skal være i CSV-format og indeholde kolonnerne 'MeteringPointIdentification', 'ReadingTs', 'Quantity', 'ReadingType'.",
      "tableheaders": {
        "filename": "Fil",
        "uploadeddatetime": "Tidspunkt",
        "status": "Status",
        "totalrows": "Rækker totalt",
        "successfulrows": "Fuldført",
        "skippedlockedrows": "Udeladt (Låst)",
        "failedrows": "Fejlet",
        "processingtime": "Behandlet"
      },
      "status": {
        "pending": "Afventer",
        "processing": "Behandler",
        "completed": "Behandlet",
        "failed": "Fejlet"
      }
    }
  },
  "chargeInformation": {
    "title": "Priselementer",
    "requestChargeInformation": "Anmod om priselementer",
    "noChargeInformationFound": "Ingen priselementer fundet",
    "chargeType": "Priselementstype",
    "chargeOccurrences": "Mængde",
    "chargeTemplate": "Lastskabelon",
    "table": {
      "type": "Priselement",
      "automationstarted": "Automatisering startet",
      "rsmstatus": "Status"
    },
    "show": {
      "title": "Vis",
      "details": "Detaljer",
      "message": "Besked"
    },
    "chargeTypes": {
      "subscription": "Abonnement",
      "fee": "Gebyr",
      "noFee": "Intet gebyr",
      "tariff": "Tarif",
      "notspecified": "Ikke specificeret"
    },
    "template": "Lastskabelon",
    "form": {
      "chooseGeneric": "Vælg...",
      "enterChargeTypeId": "Indtast priselement-ID",
      "enterDescription": "Indtast navn",
      "enterLongDescription": "Indtast beskrivelse"
    },
    "navItems": {
      "overview": "Overblik",
      "prices": "Priser",
      "setupPrices": "Prisopsætning",
      "businessTransactions": "Forretningstransaktioner"
    },
    "actions": {
      "createChargeInformation": "Opret Priselement",
      "editChargeInformation": "Redigér Priselement",
      "closeChargeInformation": "Stop Priselement",
      "requestChargeInformation": "Anmod om Priselementer",
      "shutdownChargeInformation": "Nedlæg Priselement"
    },
    "chargeTypeId": "Priselement-ID",
    "description": "Navn",
    "longDescription": "Beskrivelse",
    "observationPeriod": "Tidsopløsning",
    "observationPeriods": {
      "notSpecified": "Ikke specificeret",
      "year": "År",
      "month": "Måned",
      "day": "Dag",
      "hour": "Time",
      "quarter": "Kvarter",
      "other": "Andet"
    },
    "occurrence": "Skæringsdato",
    "detailsObservation": "Opløsning",
    "ownerEnergyPartyName": "Ejer",
    "chargePriceValidTo": "Data frem til",
    "dataHubStatus": "DataHub Status",
    "dataHub": "DataHub",
    "validFrom": "Gyldig fra",
    "validTo": "Gyldig til",
    "detailsValidTo": "Nedlæggelsesdato",
    "vatClass": "Momsgruppe",
    "vatClassOptions": {
      "novat": "Ingen moms",
      "vat": "Moms",
      "notspecified": "Ukendt"
    },
    "transparentInvoicing": "Viderefakturering",
    "chargeInformationCreated": "Priselement oprettet",
    "chargeInformationUpdated": "Priselement opdateret",
    "chargeInformationClosed": "Priselement nedlagt",
    "chargeInformationsRequested": "Priselementer er blevet anmodet",
    "associateChargeInformationSuccesful": "Priselementet er blevet tilknyttet",
    "start": "Startdato",
    "end": "Slutdato",
    "party": "Aktør",
    "sendPrices": "Indsend priser",
    "pricesSent": "Priser indsendt"
  },
  "chargeprices": {
    "price": "Pris",
    "validFrom": "Gyldig fra",
    "validTo": "Gyldig til",
    "createdBy": "Oprettet af",
    "created": "Oprettelsestidspunkt",
    "startDate": "Startdato"
  },
  "chargeSetup": {
    "title": "Prisopsætning",
    "validFrom": "Gyldig fra",
    "validTo": "Gyldig til",
    "singlePrice": "Pris",
    "loadLevelLow": "Lavlast (kr/kWh)",
    "loadLevelHigh": "Højlast (kr/kWh)",
    "loadLevelPeak": "Spidslast (kr/kWh)",
    "createdBy": "Oprettet af",
    "created": "Oprettelsestidspunkt",
    "modifiedBy": "Ændret af",
    "modified": "Ændret tidspunkt",
    "information": "Prisopsætningsinformation",
    "actions": {
      "createChargeSetup": "Opret Prisopsætning",
      "editChargeSetup": "Redigér Prisopsætning",
      "removeChargeSetup": "Fjern Prisopsætning"
    },
    "chargeSetupUpdated": "Prisopsætning opdateret",
    "chargeSetupCreated": "Prisopsætning oprettet",
    "chargeSetupRemoved": "Prisopsætning fjernet",
    "chargeSetupRemoveMessage": "Du er ved at fjerne en pris fra prisopsætningen.\nEr du sikker på, at du vil fortsætte?"
  },
  "businessTransactions": {
    "meteringPointIdentification": "Målepunkt-ID",
    "pipelineType": "Transaktionstype",
    "rsmName": "RSM-navn",
    "rsmNumber": "RSM-nummer",
    "businessReasonCode": "Årsagskode (BRC)",
    "serviceRequest": "Serviceydelse",
    "reasonCode": "Årsagskode",
    "reasonText": "Årsag",
    "requiresUserResponse": "Kræver besvarelse",
    "respondedBy": "Besvaret af",
    "respondedTS": "Besvarelsesdato",
    "requiresActionResponse": "Kræver udførsel",
    "actionRespondedBy": "Udført af",
    "actionRespondedTS": "Udførelsesdato",
    "occurrence": "Skæringsdato",
    "createdBy": "Oprettet af",
    "createdTS": "Oprettelsesdato",
    "rsmText": "Beskeddetaljer"
  },
  "search": {
    "results": {
      "noresults": "Ingen resultater fundet",
      "loadFailed": "Søgeresultaterne kunne ikke hentes. Prøv igen.",
      "notFound": "Søgeresultatet findes ikke længere. Prøv en ny søgning.",
      "retry": "Prøv igen",
      "refine": "Præcisér søgning",
      "title": "Søgning",
      "moreThan100Results": "Der blev fundet flere end 100 resultater - Tilføj filtre for indsnævning af søgninger"
    }
  },
  "serviceRequest": {
    "reply": {
      "success": "Anmodningen er blevet besvaret"
    }
  },
  "settings": {
    "notifications": "Notifikationer",
    "configuration": "Konfiguration",
    "profile": "Profil",
    "roles": "Roller",
    "table": "Tabeller",
    "title": "Indstillinger",
    "logout": "Log af",
    "navigation": {
      "collapse": "Minimér sidemenu"
    },
    "system": {
      "title": "Systemindstillinger",
      "userpreferences": "Præferencer",
      "section": {
        "language": "Sprogindstillinger",
        "visuals": "Visning",
        "header": "Header",
        "dashboard": "Dashboard"
      },
      "floatingheader": "Svævende header",
      "floatingheaderinfo": "Fastholder sideoverskriften øverst på skærmen, når du ruller ned på siden.",
      "darkmodeinfo": "Skifter applikationens farvetema til mørk tilstand. Ændringen gemmes automatisk til næste gang du logger ind.",
      "language": "Sprog",
      "languageinfo": "Vælg sproget for brugergrænsefladen.",
      "floatingtableheader": "Svævende tabelhoveder",
      "floatingtableheaderinfo": "Fastholder kolonneoverskrifterne øverst i tabellen, når du ruller ned i indholdet.",
      "tableactions": "Tabelhandlinger",
      "tabledisplay": "Visning",
      "tableexport": "Eksporter til fil",
      "tableexportinfo": "Aktiverer eksportknappen på tabeller. Giver dig mulighed for at downloade indholdet af en tabel som en CSV-fil direkte til din computer.",
      "tableclipboard": "Eksporter til udklipsholder",
      "tableclipboardinfo": "Aktiverer udklipsholderknappen på tabeller. Giver dig mulighed for at kopiere indholdet af en tabel som CSV-tekst, klar til at indsætte i f.eks. Excel.",
      "tableconfigurations": "Tabelkonfigurationer",
      "notableconfiguration": "Ingen tabelkonfigurationer fundet",
      "table": {
        "reset": "Alle tabelkonfigurationer er blevet nulstillet."
      },
      "dashboard": {
        "computedgridloss": "Vis beregnet nettabstabel",
        "computedgridlossinfo": "Viser tabellen med beregnet nettab på dashboard-siden for tidsserier. Denne funktion er i beta og kan ændre sig."
      }
    }
  },
  "status": {
    "active": "Aktiv",
    "green": "grøn",
    "inactive": "Inaktiv",
    "red": "rød",
    "unknown": "Ukendt",
    "yellow": "gul",
    "pending": "Afventer",
    "ok": "OK",
    "passive": "Passiv",
    "confirmed": "Ok",
    "rejected": "Afvist",
    "obsolete": "Forældet",
    "pendingjob": "Afventer job",
    "notapplicable": "Lokal information"
  },
  "system": {
    "menu": {
      "uncollapse": "Fold menu ud",
      "collapse": "Fold menu ind",
      "darkmode": "Mørk tilstand",
      "lightmode": "Lys tilstand"
    },
    "button": {
      "back": "Tilbage",
      "cancel": "Annullér",
      "close": "Luk",
      "confirm": "OK",
      "ok": "OK",
      "create": "Opret",
      "disband": "Nedlæg",
      "next": "Næste",
      "save": "Gem",
      "submit": "Opret",
      "edit": "Redigér",
      "attach": "Tilknyt",
      "change": "Skift",
      "request": "Anmod",
      "send": "Indsend",
      "complete": "Udfør",
      "reply": "Besvar",
      "update": "Opdatér",
      "remove": "Fjern"
    },
    "default": {
      "no": "Nej",
      "yes": "Ja"
    },
    "search": {
      "placeholder": "Søg..."
    }
  },
  "table": {
    "error": {
      "datamismatch": "Uoverensstemmelse mellem datalængde og konfiguration",
      "missingkey": "Nøgle mangler for celle"
    },
    "pagination": {
      "index": "Viser {{ start }} til {{ end }} af {{ total }}"
    },
    "noresults": "Ingen resultater at vise",
    "refresh": "Opdater tabel",
    "productidentification": {
      "title": "Produkt"
    },
    "unittype": {
      "title": "Enhed"
    },
    "processvariant": {
      "title": "Procesvariant"
    },
    "businessreasoncode": {
      "title": "Forretningsproces"
    },
    "resolution": {
      "title": "Opløsning"
    },
    "columns": {
      "title": "Tilgængelige kolonner"
    },
    "customconfig": {
      "reset": "Nulstil tabel"
    }
  },
  "connectionpoint": {
    "title": "Tilslutningspunkt",
    "identification": "Tilslutningspunktnummer",
    "alternativeIdentification": "Alternativt tilslutningspunktnummer",
    "category": "Kategori",
    "location": "Lokationsdetaljer",
    "connectionPointId": "Målepunkt-ID",
    "stationsNumber": "Stationsnummer",
    "description": "Beskrivelse",
    "masterdata": "Stamdata",
    "sharedInstallation": {
      "title": "Fælles installation",
      "hasSharedServiceLine": "Fælles Stikledning",
      "hasCollectiveMetering": "Fællesmåling",
      "numberOfInstallations": "Antal installationer",
      "categoryOfInstallations": "Kategori af installationer"
    },
    "key": "Nøgle",
    "keyFields": {
      "number": "Nøglenummer",
      "placementType": "Nøgleplacering",
      "code": "Nøglekode",
      "remarks": "Bemærkning",
      "facility": "Nøgleopbevaring"
    },
    "search": {
      "placeholder": "Søg i tilslutningspunkt...",
      "warningLimit": "Søgningen returnerede det maksimale antal resultater. Præcisér søgningen for at se alle relevante tilslutningspunkter.",
      "selectWarning": "Vælg venligst et tilslutningspunkt før du fortsætter."
    },
    "navItems": {
      "overview": "Stamdata",
      "meterframe": "Målerramme",
      "meteringpoints": "Målepunkter",
      "history": "Historik"
    },
    "actions": {
      "createConnectionPoint": "Opret Tilslutningspunkt",
      "closeConnectionPoint": "Nedlæg Tilslutningspunkt",
      "editConnectionPoint": "Redigér Tilslutningspunkt",
      "showMap": "Vis kort",
      "hideMap": "Skjul kort"
    },
    "form": {
      "enterIdentification": "Angiv tilslutningspunktnummer",
      "enterAlternativeIdentification": "Angiv alternativt tilslutningspunktnummer",
      "enterStationsNumber": "Angiv stationsnummer",
      "chooseCategory": "Vælg kategori",
      "enterMaximumPower": "Angiv tilslutningsrettighed (kW)",
      "enterMaximumCurrent": "Angiv tilslutningsrettighed (A)",
      "enterDescription": "Angiv beskrivelse"
    },
    "create": {
      "title": "Opret tilslutningspunkt",
      "general": "Stamdata",
      "location": "Lokationsdetaljer"
    },
    "edit": {
      "success": "Tilslutningspunkt opdateret"
    },
    "disband": "Nedlæg",
    "status": "Status",
    "connectionpointCreated": "Tilslutningspunkt oprettet",
    "connectionpointEdited": "Tilslutningspunkt opdateret",
    "connectionpointRemoved": "Tilslutningspunkt nedlagt",
    "connectionCannotBeRemoved": "Tilslutningspunktet indeholder aktive målerrammer og kan derfor ikke nedlægges.",
    "connectionCanBeRemoved": "Tilslutningspunktet indeholder ingen aktive målerrammer og kan derfor nedlægges. Tryk på 'Nedlæg' for at bekræfte nedlæggelsen.",
    "history": {
      "title": "Stamdatahistorik",
      "index": "Indeks",
      "date": "Dato",
      "action": "Handling",
      "user": "Bruger"
    }
  },
  "connectionRight": {
    "sectionTitle": "Tilslutningsrettigheder",
    "owner": "Tilslutningsrettighedsejer",
    "ownerConnectionPoint": "Tilslutningspunkt",
    "ownerMeterFrame": "Målerramme",
    "title": "Tilslutningsrettighed",
    "maximumPower": "Tilslutningsrettighed (kW)",
    "maximumCurrent": "Tilslutningsrettighed (A)",
    "limitedGridAccess": "Begrænset netadgang (kW)",
    "limitedGridAccessCurrent": "Begrænset netadgang (A)",
    "validFrom": "Gyldig fra",
    "changedAt": "Ændret tidspunkt",
    "comment": "Kommentar",
    "invalidDate": "Indtast en gyldig dato.",
    "futureDate": "Gyldig fra må ikke ligge efter i dag.",
    "earlierDate": "Gyldig fra må ikke ligge før den eksisterende dato.",
    "expiredWarning": "Tilslutningsrettigheden er udløbet og kan ikke ændres.",
    "historyTitle": "Tilslutningsrettighedshistorik",
    "historyEmpty": "Ingen tilslutningsrettighedshistorik",
    "changedBy": "Ændret af",
    "success": "Tilslutningsrettighed er gemt"
  },
  "systemServices": {
    "title": "Systemydelse",
    "type": "Type",
    "capacity": "Kapacitet (kW)",
    "types": {
      "NotSpecified": "-",
      "FcrUp": "FCR Op",
      "FcrDown": "FCR Ned",
      "AfrrUp": "aFRR Op",
      "AfrrDown": "aFRR Ned",
      "MfrrUp": "mFRR Op",
      "MfrrDown": "mFRR Ned"
    }
  },
  "meterFrame": {
    "title": "Målerramme",
    "details": "Detaljer",
    "create": {
      "title": "Opret målerramme"
    },
    "edit": {
      "title": "Redigér målerramme"
    },
    "close": {
      "title": "Nedlæg målerramme"
    },
    "changeMeter": {
      "currentMeter": "Nuværende måler",
      "newMeter": "Ny måler",
      "simple": "Simpelt målerskifte uden aflæste værdier",
      "precise": "Præcist målerskifte",
      "meterDetails": "Målerdetaljer",
      "summary": "Opsummering",
      "changeDate": "Skiftedato",
      "timeSeries": "Tidsserier",
      "meterStand": "Tællerstand"
    },
    "conversionFactors": {
      "A14": "A14",
      "A23": "A23",
      "R12": "R12",
      "R34": "R34"
    },
    "primaryFrame": "Tilknyttet ramme",
    "noMeterFrames": "Der er ingen målerrammer",
    "identification": "Rammenavn",
    "description": "Beskrivelse",
    "primaryMeterFrame": "Primærramme",
    "unittype": "Enhedstype",
    "conversionFactor": "Omregningsfaktor",
    "unitTypeOptions": {
      "chargingstation": "Ladestander",
      "heatpump": "Varmepumpe",
      "batterysystem": "Batterianlæg",
      "solarpowersystem": "Solceller",
      "windturbine": "Vindmølle",
      "waterturbine": "Vand",
      "gasturbine": "Gas"
    },
    "priority": "Prioritet",
    "transformer": "Transformer",
    "capacity": "Anlægsstørrelse (kW)",
    "Date": "Dato",
    "status": "Status",
    "networkPlacement": "Tilslutningsniveau",
    "networkPlacementsOptions": {
      "a0": "A0",
      "ahighplus": "A-høj plus",
      "ahigh": "A-høj",
      "alow": "A-lav",
      "bhigh": "B-høj",
      "blow": "B-lav",
      "c": "C"
    },
    "replaceMeterTitle": "Skift måler",
    "attachMeterTitle": "Tilknyt måler",
    "attachMeterSuccess": "Måler tilknyttet",
    "replaceMeterSuccess": "Måler udskiftet",
    "history": {
      "index": "Indeks",
      "date": "Dato",
      "action": "Rammehandling",
      "meterAction": "Målerhandling",
      "user": "Bruger"
    },
    "meterFrameCreated": "Målerramme oprettet",
    "meterFrameEdited": "Målerramme opdateret",
    "type": "Rammetype",
    "types": {
      "primary": "Primær",
      "station": "Station",
      "serial": "Seriel",
      "parallel": "Parallel"
    },
    "actions": {
      "createMeterFrame": "Opret målerramme",
      "editMeterFrame": "Redigér målerramme",
      "closeMeterFrame": "Nedlæg målerramme",
      "createMeter": "Opret måler",
      "createmeterwithoutattach": "Opret måler uden tilknytning",
      "attachMeter": "Tilknyt måler",
      "editMeter": "Redigér måler",
      "removeMeter": "Nedlæg måler",
      "replaceMeter": "Skift måler",
      "addConversionFactor": "Tilføj Omregningsfaktor",
      "changeQuadrantMapping": "Skift Kvadrant Mapning"
    },
    "form": {
      "chooseType": "Vælg rammetype",
      "enterPriority": "Angiv prioritet",
      "enterTransformer": "Angiv Transformer",
      "enterMaximumPower": "Angiv Tilslutningsrettighed (kW)",
      "enterLimitedGridAccess": "Angiv Begrænset netadgang (kW)",
      "enterMaximumCurrent": "Angiv Tilslutningsrettighed (A)",
      "chooseNetworkPlacement": "Vælg rammetype",
      "chooseGeneric": "Vælg...",
      "chooseUnitType": "Vælg enhedstype",
      "enterCapacity": "Angiv Anlægskapacitet (kW)",
      "enterIdentification": "Angiv navn",
      "enterDescription": "Angiv beskrivelse",
      "enterConversionFactor": "Angiv omregningsfaktor"
    },
    "meterFrameRemoved": "Målerramme nedlagt",
    "meterFrameCanBeRemoved": "Målerrammen indeholder ingen aktive målere og kan derfor nedlægges. Tryk på 'Nedlæg' for at bekræfte nedlæggelsen.",
    "meterFrameCannotBeRemoved": "Målerrammen kan ikke nedlægges, da der er en aktiv måler i rammen. Nedlæg måleren for at rammen kan nedlægges."
  },
  "conversionFactorModal": {
    "title": "Tilføj Omregningsfaktor",
    "applyTo": "Område",
    "applyToMeterframe": "Målerramme",
    "applyToMeter": "Måler",
    "success": "Omregningsfaktor tilføjet",
    "recalculationWarning": "Ændringer i omregningsfaktorer vil medføre en genberegning af tidsserierne for den valgte periode og sendes til DataHub.",
    "mirrorValues": "Ensret værdier"
  },
  "quadrantMappingModal": {
    "title": "Skift Kvadrant Mapning",
    "validFrom": "Gyldig fra",
    "mappings": "Kvadrant mapninger",
    "mappingA14": "A14 (Forbrug)",
    "mappingA23": "A23 (Produktion)",
    "mappingR12": "R12 (Reaktiv positiv)",
    "mappingR34": "R34 (Reaktiv negativ)",
    "resendTimeSeries": "Gensend tidsserier for perioden",
    "resendValidTo": "Gyldig til",
    "resendValidToHint": "Denne dato påvirker kun gensendelse af tidsserier – ikke selve kvadrantmapningen. Hvis der ikke vælges en slutdato, bruges dags dato.",
    "syncWarning": "Ændringer i kvadrant mapning vil automatisk opdatere tilknyttede målepunkter og kan udløse gensendelse af data til DataHub.",
    "success": "Kvadrant mapning opdateret"
  },
  "htxMeterModal": {
    "quadrantSyncWarning": "Kvadranten styres fra målerens kvadrantmapning og kan ikke ændres manuelt."
  },
  "conversionFactorHistory": {
    "sectionTitle": "Omregningsfaktor",
    "meterframeTitle": "Målerramme",
    "meterTitle": "Måler",
    "validFrom": "Gyldig fra",
    "validTo": "Gyldig til",
    "created": "Oprettet",
    "createdBy": "Oprettet af"
  },
  "model": {
    "name": "Model",
    "productionYear": "Produktionsår",
    "numberOfDigits": "Målercifre",
    "readingType": "Type"
  },
  "vendor": {
    "name": "Fabrikat"
  },
  "resolution": {
    "notspecified": "Ikke angivet",
    "year": "År",
    "month": "Måned",
    "day": "Dag",
    "hour": "Time",
    "quarter": "Kvarter",
    "other": "Andet"
  },
  "meterpointsubtype": {
    "notspecified": "Ikke angivet",
    "physical": "Fysisk",
    "virtual": "Virtuel",
    "calculated": "Beregnet"
  },
  "meterreadingtype": {
    "notspecified": "Ikke angivet",
    "accumulated": "Akkumuleret",
    "balanced": "Salderende",
    "none": "Ingen"
  },
  "date": {
    "validFrom": "Gyldig fra",
    "validTo": "Gyldig til",
    "enterDate": "Angiv dato"
  },
  "vee": {
    "title": "VEE-grupper",
    "editModal": {
      "title": "Redigér VEE-gruppe"
    },
    "createModal": {
      "title": "Opret VEE-gruppe"
    },
    "action": {
      "add": "Opret",
      "edit": "Redigér"
    },
    "overview": {
      "title": "Overblik"
    },
    "meteringpoints": {
      "title": "Målepunkter"
    },
    "create": {
      "name": "Navn",
      "estimateAfter": "Timer inden der estimeres",
      "priority": "Prioritet",
      "method": "Metode",
      "sendvalues": "Send målte værdier",
      "active": "Aktiv",
      "manualestimation": "Hvis der ikke vælges en aktiv estimeringsmetode, vil manuel estimering skulle benyttes.",
      "activeestimations": "Aktive estimeringsmetoder",
      "availableestimations": "Tilgængelige estimeringsmetoder",
      "noactiveestimations": "Ingen aktive estimeringsmetoder",
      "noavailableestimations": "Ingen tilgængelige estimeringsmetoder",
      "created": "VEE-gruppe oprettet",
      "updated": "VEE-gruppe opdateret"
    },
    "details": {
      "title": "Detaljer",
      "estimationMethods": "Estimeringsmetoder",
      "name": "Navn",
      "hoursBeforeEstimation": "Timer før estimering",
      "attachedMeteringPoints": "Tilknyttede målepunkter",
      "createdBy": "Oprettet af",
      "priority": "Prioritet",
      "info": "Er der ikke valgt en aktiv estimeringsmetode, vil manuel estimering skulle benyttes.",
      "editMenu": "Redigér",
      "method": "Metode",
      "sendData": "Send målte værdier"
    },
    "meteringpoint": {
      "id": "Id",
      "billing": "Afregning",
      "address": "Adresse",
      "type": "Målepunktstype",
      "consumption": "Forventet årsforbrug",
      "attachMeteringPoint": "Tilknyt målepunkt",
      "removeMeteringPoint": "Fjern målepunkter",
      "expectedConsumptionFrom": "Forventet årsforbrug - fra",
      "expectedConsumptionTo": "Forventet årsforbrug - til",
      "streetName": "Vejnavn",
      "streetNumber": "Husnummer",
      "postalCode": "Postnummer",
      "meteringPointId": "Målepunkt-ID",
      "estimationGroupName": "Estimeringsgruppenavn",
      "meteringPointNoEstimationGroup": "Uden estimeringsgruppe",
      "meteringpointattached": "Målepunktet er blevet tilknyttet",
      "meteringpointremoved": "Målepunktet er blevet fjernet",
      "removeinfo": "Er du sikker på at du ønsker at fjerne de valgte målepunkter?"
    },
    "changebilling": {
      "title": "Skift afregningsform"
    }
  },
  "action": {
    "add": "Opret",
    "edit": "Redigér",
    "close": "Nedlæg",
    "replace": "Skift",
    "request": "Anmod",
    "remove": "Fjern"
  },
  "historicalAction": {
    "notSpecified": "[NotSpecified]",
    "remove": "Nedlagt",
    "update": "Opdateret",
    "create": "Oprettet",
    "disconnect": "Afbrudt",
    "connect": "Tilsluttet"
  },
  "actorregister": {
    "title": "Aktørregister",
    "search": {
      "businessrole": "Aktørtype",
      "name": "Navn",
      "identification": "GLN-Nummer",
      "terminationdate": "Ophørsdato"
    },
    "create": {
      "title": "Opret aktør",
      "success": "Aktør oprettet"
    },
    "edit": {
      "title": "Redigér aktør",
      "success": "Aktør redigeret"
    }
  },
  "actor": {
    "businessrole": {
      "balanceresponsibleparty": "Balanceansvarlig",
      "gridaccessprovider": "Netvirksomhed",
      "balancepowersupplier": "Elleverandør",
      "imbalancesettlementresponsible": "Ubalanceansvarlig",
      "meteringpointadministrator": "Målepunktsadministrator",
      "metereddataaggregator": "Aggregator",
      "systemoperator": "Energinet",
      "metereddataresponsible": "Måledataoperatør"
    }
  },
  "enum": {
    "serviceRequestCode": {
      "notSpecified": "Ikke angivet",
      "disconnect": "Ordinær afbrydelse af målepunkt (D01)",
      "closeDown": "Nedlæggelse af målepunkt (D02)",
      "connect": "Genåbning af målepunkt (D03)",
      "readingRequest": "Ekstra aflæsning (D04)",
      "meterCheck": "Målerundersøgelse (D05)",
      "flexChange": "Skift til flexafregning (D06)",
      "nonProfiledChange": "Skift til timeafregning (D07)",
      "disconnectDueToEndOfSupply": "Afbrydelse ved leveranceophør (D08)",
      "theMunicipalityIsInvolvedInTheDisconnection": "Kommunen er inddraget i afbrydelsen (D09)",
      "thePoliceIsInvolvedInTheDisconnection": "Politiet er inddraget i afbrydelsen (D10)",
      "theBailiffsCourtIsInvolvedInTheDisconnection": "Fogedretten er inddraget i afbrydelsen (D11)",
      "ordinaryDisconnectionAgreedWithTheCustomer": "Afbrydelse aftalt med kunden (D12)",
      "otherReason": "Anden årsag (D13)",
      "etablishElectricHeating": "(D14)",
      "removeElectricHeating": "(D15)"
    },
    "address": {
      "address": "Bopælsadresse",
      "access": "Adgangsadresse"
    },
    "rsmStatus": {
      "notSet": "Ikke sat",
      "failed": "Fejlet",
      "completed": "Gennemført",
      "waiting": "Afventer",
      "aborted": "Afbrudt",
      "awaitingNetworkPlacement": "Afventer placering i netværk",
      "manuallyHandled": "Manuelt håndteret"
    },
    "pipelinetype": {
      "notspecified": "Ukendt",
      "request": "Forespørgsel",
      "response": "Svar",
      "notify": "Orientering",
      "todo": "ToDo",
      "todohandled": "ToDo håndteret"
    },
    "physicalstatus": {
      "notspecified": "Ikke angivet",
      "closeddown": "Nedlagt",
      "new": "Nyoprettet",
      "connected": "Tilsluttet",
      "disconnected": "Afbrudt"
    },
    "quadrant": {
      "notspecified": "[NotSpecified]",
      "consumption": "Forbrug (A+)",
      "production": "Produktion (A-)",
      "reactivepositive": "Reaktiv (R+)",
      "reactivenegative": "Reaktiv (R-)"
    },
    "quadrantshort": {
      "notspecified": "",
      "consumption": "A+",
      "production": "A-",
      "reactivepositive": "R+",
      "reactivenegative": "R-"
    },
    "estimationmethod": {
      "notspecified": "Ikke angivet",
      "sameasdaybefore": "Samme værdi driftsdøgnet før",
      "sameassevendaysbefore": "Samme værdi 7 dage før driftsdøgnet",
      "sameas1monthbefore": "Samme værdi 28 dage før driftsdøgnet",
      "controlmeter": "Kontrolmåler",
      "ghostmeter": "Måler findes ikke i VisionAir",
      "zerovaluemeteringpointdisconnected": "0 værdier ved afbrydelse",
      "zerovalueinsideday": "Tællerstandsdifference ved hul inden for driftsdøgn",
      "manualnotspecified": "Ikke angivet",
      "manualevenly": "Jævn fordeling",
      "manuallastposition": "Sidste position",
      "manualprofile": "Profil",
      "manualothermeteringpoint": "Andet målepunkt",
      "advancedvee": "Machine Learning",
      "manualadvancedvee": "Machine Learning (Manuelt tilrettet)",
      "advancedveelookback": "Machine Learning (Historisk periode)",
      "advancedveeclustering": "Machine Learning (Vennebaseret)",
      "advancedveeevhandler": "Machine Learning (Elbiler)",
      "zerovaluemeterchange": "0 værdier ved målerskifte"
    },
    "settlementmethod": {
      "notspecified": "Ikke angivet",
      "flexsettled": "Flexafregnet",
      "profiled": "Skabelonafregnet",
      "nonprofiled": "Timeafregnet"
    },
    "resolution": {
      "notspecified": "Ikke angivet",
      "year": "År",
      "month": "Måned",
      "day": "Dag",
      "hour": "Time",
      "quarter": "Kvarter"
    },
    "settlement": {
      "businessreasoncode": {
        "notspecified": "Ikke angivet",
        "temporary": "Foreløbig (D03)",
        "firstsettlement": "Balancefiksering (D04)",
        "secondsettlement": "Engrosfiksering (D05)",
        "latestavailablevalue": "Måledata baseret på aktuelle værdier (D09)",
        "correctionsettlement": "Korrektionsafstemning (D32)"
      },
      "processvariant": {
        "notspecified": "",
        "firstrun": "1. korrektion",
        "secondrun": "2. korrektion",
        "thirdrun": "3. korrektion"
      }
    },
    "chargetype": {
      "notspecified": "Ikke angivet",
      "subscription": "Abonnement",
      "fee": "Gebyr",
      "tariff": "Tarif"
    },
    "meteringpoint": {
      "connectiontype": {
        "notspecified": "Ikke angivet",
        "directconnected": "Direkte tilsluttet",
        "installationconnected": "Installationstilsluttet"
      },
      "meteringpointtype": {
        "notspecified": "Ikke angivet",
        "veproduction": "D01 VE-Produktion",
        "analysis": "D02 Analysemålepunkt",
        "surplusproductiongroup": "D04 Overskudsproduktion gruppe 6",
        "netproduction": "D05 Nettoproduktion",
        "supplytogrid": "D06 Leveret til net",
        "consumptionfromgrid": "D07 Forbrugt fra net",
        "wholesaleservices": "D08 Afregningsgrundlag / Information",
        "ownproduction": "D09 Egenproduktion",
        "netfromgrid": "D10 Netto fra net",
        "nettogrid": "D11 Netto til net",
        "totalconsumption": "D12 Bruttoforbrug",
        "gridlosscorrection": "D13 Nettabskorrektion",
        "electricalheating": "D14 Elvarme",
        "nettoconsumption": "D15 Nettoforbrug",
        "internaluse": "D99 Intern brug",
        "consumption": "E17 Forbrugsmålepunkt",
        "production": "E18 Produktionsmålepunkt",
        "exchange": "E20 Udvekslingsmålepunkt",
        "otherconsumption": "D17 Øvrigt forbrug",
        "otherproduction": "D18 Øvrig produktion",
        "exchangereactiveenergy": "D20 Udveksling - Reaktiv energi",
        "effectpayment": "D19 Effektbetaling",
        "collectivenetproduction": "D21 Kollektiv nettoproduktion",
        "collectivenetconsumption": "D22 Kollektivt nettoforbrug"
      },
      "assettype": {
        "notspecified": "Ikke angivet",
        "steamturbinebackpressuremode": "D01 - Dampturbine med modtryksdrift",
        "gasturbine": "D02 - Gasturbine",
        "combinedcycle": "D03 - Combined cycle",
        "combustionenginegas": "D04 - Forbrændingsmotor Gas",
        "steamturbinewithcondensation": "D05 - Dampturbine med kondens/damp",
        "boiler": "D06 - Kedel",
        "stirlingengine": "D07 - Stirlingmotor",
        "permanentconnectedelectricalenergystoragefacilities": "D08 - Permanent tilsluttede elektriske energilageranlæg",
        "temporaryconnectedelectricalenergystoragefacilities": "D09 - Midlertidigt tilsluttede elektriske energilageranlæg",
        "fuelcells": "D10 - Brændselsceller",
        "photovoltaiccells": "D11 - Solceller",
        "windturbines": "D12 - Vindmøller",
        "hydroelectricpower": "D13 - Vandkraft",
        "wavepower": "D14 - Bølgekraft",
        "mixedproduction": "D15 - Blandet produktion",
        "productionwithelectricalenergystoragefacilities": "D16 - Produktion med elektriske energilageranlæg",
        "powertox": "D17 - Power-to-X",
        "regenerativedemandfacility": "D18 - Regenerative forbrugsanlæg",
        "combustionenginediesel": "D19 - Forbrændingsmotor Dieselmotor",
        "combustionenginebio": "D20 - Bioforbrændingsmotor",
        "unknowntecnology": "D99 - Ukendt teknologi"
      },
      "netsettlementgroup": {
        "notspecified": "Ikke angivet",
        "netsettlementgroup0": "Ingen nettoafregningsgruppe",
        "netsettlementgroup1": "Nettoafregningsgruppe 1",
        "netsettlementgroup2": "Nettoafregningsgruppe 2",
        "netsettlementgroup3": "Nettoafregningsgruppe 3",
        "netsettlementgroup4": "Nettoafregningsgruppe 4",
        "netsettlementgroup5": "Nettoafregningsgruppe 5",
        "netsettlementgroup6": "Nettoafregningsgruppe 6",
        "netsettlementgroup99": "Nettoafregningsgruppe 99"
      },
      "meterreadingtype": {
        "notspecified": "Ikke angivet",
        "accumulated": "Akkumuleret",
        "balanced": "Salderende",
        "none": "Ingen"
      },
      "meteringpointsubtype": {
        "notspecified": "Ikke angivet",
        "physical": "Fysisk",
        "virtual": "Virtuel",
        "calculated": "Beregnet"
      },
      "physicalstatus": {
        "notspecified": "Ikke angivet",
        "closeddown": "Nedlagt",
        "new": "Nyoprettet",
        "connected": "Tilsluttet",
        "disconnected": "Afbrudt"
      },
      "productcharacteristic": {
        "tariff": "Tidstarif",
        "fuelquantity": "Brændselsmængde",
        "poweractive": "Aktiv effekt",
        "powerreactive": "Reaktiv effekt",
        "energyactive": "Aktiv energi",
        "energyreactive": "Reaktiv energi",
        "notspecified": "Ikke angivet"
      },
      "settlementmethod": {
        "undefined": "",
        "notspecified": "",
        "flexsettled": "Flexafregnet",
        "profiled": "Skabelonafregnet",
        "nonprofiled": "Timeafregnet"
      },
      "unittype": {
        "kwh": "kWh",
        "kva": "kVA",
        "kvarh": "kVArh",
        "kvar": "kVAr",
        "wh": "Wh",
        "varh": "VArh",
        "var": "VAr",
        "kw": "kW",
        "mvar": "MVAr",
        "mw": "MW",
        "mwh": "MWh",
        "tonne": "Tonne",
        "ampere": "Ampere",
        "stk": "Stk",
        "notspecified": "Ikke angivet"
      },
      "disconnectiontype": {
        "notspecified": "Ikke angivet",
        "remotedisconnection": "Fjernafbrydelse",
        "manualdisconnection": "Manuel afbrydelse"
      },
      "electricalheatingstatus": {
        "title": "Status",
        "notSpecified": "",
        "d14missing": "Mangler",
        "d14awaitingcreation": "Afventer",
        "d14creationfailed": "Oprettelse fejlet",
        "d14mustberemoved": "D14 skal fjernes",
        "d14awaitingremoval": "Afventer nedlæggelse",
        "d14removalfailed": "Fjernelse fejlet"
      }
    },
    "datahub": {
      "status": {
        "notspecified": "Ikke angivet",
        "undefined": "Ikke angivet",
        "rejected": "Afvist",
        "confirmed": "Bekræftet",
        "pending": "Afventer",
        "pendingjob": "Afventer Job",
        "obsolete": "Forældet",
        "notapplicable": "Lokal information"
      }
    },
    "quantityquality": {
      "notspecified": "Ikke angivet",
      "estimated": "Estimeret",
      "asread": "Aflæst",
      "revised": "Revideret",
      "calculated": "Beregnet",
      "missing": "Manglende værdi",
      "incomplete": "Ufuldstændig"
    },
    "missingdatastatus": {
      "calculationfailed": "Fejl i beregning",
      "calculationresolutionmismatch": "Opløsningsmismatch mellem målepunkt og måler",
      "estimatedvalues": "Estimerede værdier",
      "estimationcandidate": "Estimeringskandidat",
      "estimationfailed": "Estimering fejlet",
      "failedaddmetereddata": "FailedAddMeteredData",
      "infinitecalculationloop": "InfiniteCalculationLoop",
      "missingcalculationrequirement": "Mangler beregningsgrundlag",
      "missingdatareceived": "Hullerlog",
      "missingestimationgroup": "Mangler estimeringsgruppe",
      "missingformula": "Manglende beregningsformel",
      "missingvalues": "Afventer beregning eller estimering",
      "notspecified": "Ikke angivet",
      "reestimationcandidate": "Reestimeringskandidat",
      "sendfailed": "Afsendelse fejlet",
      "validationerror": "Valideringsfejl"
    },
    "readingtype": {
      "notspecified": "Ikke angivet",
      "read": "Målt (aflæst)",
      "missing": "Mangler",
      "calculated": "Beregnet",
      "estimated": "Estimeret",
      "deleted": "Slettet",
      "ok": "Målt"
    },
    "metereddatasource": {
      "notspecified": "Ikke angivet",
      "sent": "DHM",
      "requested": "DataHub"
    },
    "servicerequest": {
      "responsereasontype": {
        "d41": "Kommunen skal inddrages i afbrydelsen",
        "d42": "Politiet skal inddrages i afbrydelsen",
        "d43": "Fogedretten skal inddrages i afbrydelsen",
        "d44": "Anden afvisningsårsag",
        "d45": "Afvisningsårsag 5",
        "d58": "Ingen adgang til måler"
      }
    }
  },
  "role": {
    "title": "Rolle",
    "description": "Beskrivelse",
    "veewriter": {
      "description": "Kan redigere VEE-grupper"
    },
    "connectionpointreader": {
      "description": "Kan se tilslutningspunkter"
    },
    "veereader": {
      "description": "Kan se VEE-grupper"
    },
    "connectionpointwriter": {
      "description": "Kan redigere tilslutningspunkt"
    },
    "meteringpointwriter": {
      "description": "Kan redigere målepunkter"
    },
    "chargeinformationreader": {
      "description": "Kan se priselementer"
    },
    "meteringpointreader": {
      "description": "Kan se målepunkter"
    },
    "aggregateddatareader": {
      "description": "Kan se afstemning"
    },
    "chargeinformationwriter": {
      "description": "Kan redigere priselementer"
    },
    "topologyreader": {
      "description": "Kan se topologien"
    },
    "topologywriter": {
      "description": "Kan redigere topologien"
    }
  },
  "dar": {
    "address": "Adresse"
  },
  "meteringPoint": {
    "meteringPointId": "Målepunkt-ID",
    "timeSeries": {
      "consumption": "Kvantitet",
      "readingValue": "Tællerstand",
      "source": "Kilde",
      "serialNumber": "Serienummer",
      "readingType": "Aflæsningstype",
      "consumptionType": "Aflæsningstype",
      "estimationMethod": "Estimeringsmetode",
      "packageId": "Pakke-ID",
      "readingTs": "Tidspunkt",
      "registered": "Registreret",
      "measured": "Afl�st"
    },
    "create": {
      "success": "Målepunkt oprettet",
      "meteringPointId": "Målepunkt-ID",
      "meteringPointType": "Målepunktstype",
      "meteringPointSubType": "Målepunktsart",
      "validFrom": "Gyldig fra",
      "gridArea": "Netområde",
      "unitType": "Energienhed",
      "product": "Produkt",
      "meterId": "M�lerID",
      "disconnectionType": "Afbrydelsestype",
      "netSettlementGroup": "Nettoafregningsgruppe",
      "connectionType": "Tilslutningstype",
      "assetType": "Anlægsteknologi",
      "productionobligation": "Aftagepligt",
      "maximumPower": "Effektgrænse (kW)",
      "maximumCurrent": "Effektgrænse (A)",
      "meterReadingOccurrence": "Aflæsningsfrekvens",
      "productCharacteristicIdentification": "Produkt",
      "settlementMethod": "Afregningsform",
      "capacity": "Kapacitet (kW)",
      "fromArea": "Fra net",
      "toGrid": "Til net",
      "powerPlantIdentification": "Værks-GSRN",
      "meterNumber": "Målernummer",
      "numberOfDigits": "Målercifre",
      "meterReadingUnit": "Aflæsningsenhed",
      "meterReadingType": "Målertype",
      "parentMeteringPointIdentification": "Parent målepunkts-ID",
      "connectionPointId": "Tilslutningspunkt-ID",
      "addressAdded": "Adresse tilføjet",
      "meteringPointParentAdded": "Målepunkts-parent tilføjet",
      "electricalHeating": "Elvarme",
      "template": {
        "title": "Skabelon",
        "description": "Skabeloner kan forkorte oprettelsesprocessen, ved at give mulighed for at præ-udfylde en lang række felter"
      },
      "address": {
        "title": "Installationsadresse",
        "description": "Adressen kan enten angives ved direkte søgning fra DAR, eller ved at angive den manuelt."
      },
      "meter": {
        "title": "Måler og detaljer",
        "description": "Information om eventuel måler, samt målepunktsdetaljer"
      },
      "meteringPointDetails": {
        "title": "Målepunktsdetaljer",
        "description": "Definition af målepunktets karakter og type."
      },
      "child": {
        "title": "Child-målepunkt",
        "description": "Benyttes hvis det oprettede målepunkt er child til et andet (parent) målepunkt."
      },
      "creationDetails": {
        "title": "Oprettelsesdetaljer",
        "description": ""
      },
      "readingBilling": {
        "title": "Aflæsning og afregning",
        "description": ""
      },
      "areaDetails": {
        "title": "Områdedetaljer",
        "description": "Angivelse af tilknytnings- og leveranceområde."
      },
      "installationDetails": {
        "title": "Installation",
        "description": "Installation dækker over den tekniske installation på målepunktet, såsom tilladte effektgrænser og tilladte energienhed."
      },
      "ownProduction": {
        "title": "Egenproduktion",
        "description": "Egenproduktion dækker over målepunkter der selv producerer strøm, eksempelvis igennem solceller, vindmøller eller lignende."
      },
      "connectionPoint": {
        "title": "Tilslutningspunkt",
        "description": "E17, E18 og E20 kræver et tilslutningspunkt for at kunne oprettes."
      },
      "exchange": {
        "title": "Udvekslingsdetaljer",
        "description": "Angivelse af afsender og modtagernet"
      }
    },
    "controlMeter": {
      "stopControlMeter": {
        "wrongType": "Valgte måler er ikke en kontrolmåler"
      }
    },
    "readingCharacteristics": {
      "title": "Aflæsningsform",
      "notSpecified": "",
      "automaticMeterReading": "Fjernaflæst",
      "manualMeterReading": "Manuelt aflæst",
      "none": "Ingen"
    },
    "assetType": {
      "title": "Anlægsteknologi",
      "steamTurbineBackPressureMode": "D01 - Dampturbine med modtryksdrift",
      "gasturbine": "D02 - Gasturbine",
      "combinedCycle": "D03 - Combined cycle",
      "combustionEngineGas": "D04 - Forbrændingsmotor Gas",
      "steamTurbineWithCondensation": "D05 - Dampturbine med kondens/damp",
      "boiler": "D06 - Kedel",
      "stirlingEngine": "D07 - Stirlingmotor",
      "permanentConnectedElectricalEnergyStorageFacilities": "D08 - Permanent tilsluttede elektriske energilageranlæg",
      "temporaryConnectedElectricalEnergyStorageFacilities": "D09 - Temporært tilsluttede elektriske energilageranlæg",
      "fuelCells": "D10 - Brændselsceller",
      "photovoltaicCells": "D11 - Solceller",
      "windTurbines": "D12 - Vindmøller",
      "hydroelectricPower": "D13 - Vandkraft",
      "wavePower": "D14 - Bølgekraft",
      "mixedProduction": "D15 - Blandet produktion",
      "productionWithElectricalEnergyStorageFacilities": "D16 - Produktion med elektriske energilageranlæg",
      "powerToX": "D17 - Power-to-X",
      "regenerativeDemandFacility": "D18 - Regenerative forbrugsanlæg",
      "combustionEngineDiesel": "D19 - Forbrændingsmotor Dieselmotor",
      "combustionEngineBio": "D20 - Bioforbrændingsmotor",
      "unknownTecnology": "D99 - Ukendt teknologi",
      "notSpecified": "Ingen teknologi"
    },
    "connectionType": {
      "title": "Tilslutningstype",
      "notSpecified": "",
      "directConnected": "Direkte tilsluttet",
      "installationConnected": "Installationstilsluttet"
    },
    "meter": {
      "create": {
        "success": "Måler oprettet"
      }
    },
    "edit": {
      "title": "Redigér målepunkt",
      "success": "Målepunkt opdateret"
    },
    "calculation": {
      "parameter": {
        "name": "Parameter"
      },
      "create": {
        "title": "Skift beregning"
      },
      "htx": {
        "title": "Lav HTX"
      }
    },
    "list": {
      "create": {
        "title": "Opret"
      },
      "edit": {
        "title": "Redigér"
      },
      "coredata": {
        "title": "Anmod om stamdata"
      },
      "close": {
        "title": "Nedlæg"
      }
    },
    "historical": {
      "tabs": {
        "physicalDetails": "Fysiske detaljer",
        "locationDetails": "Lokationsdetaljer",
        "meteringDetails": "Måledetaljer",
        "meterDetails": "Målerdetaljer"
      }
    },
    "details": {
      "parentID": "Parent-ID",
      "gridArea": "Netområde",
      "fromGrid": "Fra netområde ID",
      "toGrid": "Til netområde ID",
      "gsrn": "Værks-GSRN"
    },
    "find": {
      "modal": {
        "title": "Fremsøg målepunkt"
      }
    },
    "search": {
      "meteringPointType": "Målepunktstype",
      "physicalStatus": "Tilslutningsstatus",
      "meterNumber": "Målernummer",
      "meteringPointID": "Målepunkt-ID",
      "selectWarning": "Du har ikke valgt et målepunkt"
    },
    "timeseries": {
      "search": {
        "start": "Startdato",
        "resolution": "Tidsopløsning",
        "dataHubStatus": "DataHub-status",
        "source": "Kilde",
        "onlyLatest": "Gældende",
        "readingType": "Aflæsningstype",
        "estimationMethod": "Estimeringsmetode",
        "packageId": "Pakke-ID"
      }
    },
    "action": {
      "copy": {
        "success": "Målepunktsnummer kopieret til udklipsholder."
      },
      "connect": {
        "success": "Tilslutning gennemført",
        "source": {
          "title": "Kobling til tidsserieberegning",
          "required": "Vælg om målepunktet skal kobles til en målers kvadrant eller en beregningsformel",
          "meter": "Målerkvadrant",
          "meterDescription": "Tidsserien hentes fra en kvadrant på en fysisk måler",
          "calculation": "Beregningsformel",
          "calculationDescription": "Tidsserien beregnes ud fra andre målepunkter",
          "currentSubtype": "Nuværende målepunktsart: {{ subtype }}",
          "subtypeInfo": "Målepunktsarten opdateres automatisk (Fysisk ved måler, Virtuel ved beregningsformel), når tilslutningen er bekræftet af DataHub."
        }
      },
      "shutdown": {
        "title": "Nedlæg"
      }
    }
  },
  "connectionPoint": {
    "meterFrame": {
      "create": "Opret målerramme",
      "edit": "Redigér målerramme",
      "remove": "Nedlæg målerramme",
      "meter": {
        "create": "Opret måler",
        "createmeterwithoutattach": "Opret måler uden tilknytning",
        "attach": "Tilknyt måler",
        "edit": "Redigér måler",
        "remove": "Fjern måler",
        "change": "Skift måler"
      }
    },
    "meteringPoint": {
      "create": "Opret tilknyttet målepunkt"
    },
    "action": {
      "copy": {
        "success": "Tilslutningspunktnummer kopieret til udklipsholder."
      }
    },
    "create": {
      "title": "Opret tilslutningspunkt",
      "relatedMeteringPoint": "Opret tilknyttet målepunkt",
      "coredata": {
        "title": "Stamdata",
        "description": "Opret stamdata for tilslutningspunktet"
      },
      "alternative": {
        "title": "Yderligere stamdata",
        "description": "Manuel konfiguration af tilslutningspunkt-id og station. Felterne udfyldes automatisk, hvis de efterlades tomme"
      },
      "form": {
        "category": "Kategori",
        "maximumPower": "Tilslutningsrettighed (kW)",
        "maximumCurrent": "Tilslutningsrettighed (A)",
        "description": "Beskrivelse",
        "identification": "Tilslutningspunkt-ID",
        "alternativeIdentification": "Alternativt tilslutningspunktnummer",
        "stationsNumber": "Stationsnummer"
      }
    }
  },
  "timeSeries": {
    "missing": {
      "time": "Tidspunkt",
      "consumption": "Forbrug",
      "measured": "Målt",
      "estimated": "Estimeret",
      "wantsDataLocked": "Lås tidsserier",
      "success": "Redigering af tidsserier gemt"
    }
  },
  "dropDown": {
    "noResults": "Ingen resultater fundet"
  },
  "hotkeys": {
    "title": "Tastaturgenveje",
    "empty": "Ingen genveje tilgængelige på denne side",
    "group": {
      "navigation": "Global navigation",
      "page": "Denne side",
      "table": "Tabelnavigation"
    },
    "label": {
      "openIndex": "Vis tastaturgenveje",
      "openMenu": "Åbn handlingsmenu",
      "createMeteringPoint": "Opret målepunkt",
      "createConnectionPoint": "Opret tilslutningspunkt",
      "refreshTable": "Opdater tabel",
      "tableNavNext": "Næste række",
      "tableNavPrev": "Forrige række"
    },
    "footer": {
      "close": "Luk"
    }
  },
  "gridloss": {
    "title": "Aggregeret i DataHub",
    "tooltip": "Aggregeringer beregnet af DataHub ud fra de måledata, EnergyConnect har indsendt. Det er de officielle tal, som DataHub bruger videre i markedet.",
    "startDate": "Startdato",
    "periodLabel": "Periode",
    "period": {
      "week": "1 uge (7 dage)",
      "twoWeeks": "2 uger (14 dage)",
      "threeWeeks": "3 uger (21 dage)",
      "month": "1 måned (30 dage)"
    },
    "export": "Eksporter",
    "export.image": "Billede (PNG)",
    "export.csv": "Tabel (CSV)",
    "fullscreen": "Fuldskærm",
    "fullscreen.close": "Luk fuldskærm",
    "error": "Der opstod en fejl ved hentning af nettabsdata",
    "series": {
      "netLoss": "Nettab",
      "systemCorrection": "Systemkorrektion",
      "e17": "E17 Forbrug",
      "e17Flex": "E17 Flexafregnet",
      "e17Hour": "E17 Timeafregnet",
      "e18": "E18 Produktion",
      "e20": "E20 Udveksling"
    },
    "computed": {
      "title": "Aggregeret i EnergyConnect",
      "tooltip": "Aggregeringer beregnet af EnergyConnect ud fra vores egne måledata. De kan bruges til at kontrollere DataHubs tal. Forskelle kan skyldes data, der mangler eller er forsinket i DataHub, eller rettelser, som endnu ikke er sendt.",
      "synchronizeCharts": "Synkroniser grafer",
      "beta": {
        "label": "Tidlig beta:",
        "disclaimer": "Beregningerne der vises her er under aktiv udvikling og er muligvis ikke helt korrekte. Brug dem ikke som grundlag for driftsbeslutninger."
      }
    }
  }
}
